import type { Bilingual } from '../lib/LanguageContext';

export interface BrandingCopy {
  title: Bilingual;
  tagline: Bilingual;
}

export const brandingCopy: BrandingCopy = {
  title: {
    id: 'TSL Learning Portal',
    ar: 'بوابة التعلّم',
  },
  tagline: {
    id: 'Mempelajari dasar-dasar Islam secara bertahap, mudah, dan fleksibel.',
    ar: 'تعلم أساسيات الإسلام بشكل تدريجي وسهل ومرن.',
  },
};

export const copy = {
  common: {
    loading: { id: 'Memuat...', ar: 'جاري التحميل...' },
    cancel: { id: 'Batal', ar: 'إلغاء' },
    save: { id: 'Simpan', ar: 'حفظ' },
    error: { id: 'Terjadi Kesalahan', ar: 'حدث خطأ' },
    status: { id: 'Status', ar: 'الحالة' },
    code: { id: 'Kode', ar: 'الرمز' },
    back: { id: 'Kembali', ar: 'العودة' },
    next: { id: 'Selanjutnya', ar: 'التالي' },
    submit: { id: 'Kirim', ar: 'إرسال' },
    success: { id: 'Berhasil', ar: 'نجاح' },
    close: { id: 'Tutup', ar: 'إغلاق' },
    pending: { id: 'Tertunda', ar: 'قيد الانتظار' },
    noDescription: { id: 'Tidak ada deskripsi', ar: 'لا يوجد وصف' },
    minutes: { id: 'Menit', ar: 'دقائق' },
    tbd: { id: 'Segera Diumumkan', ar: 'يُحدد لاحقاً' },
    notSet: { id: 'Belum diatur', ar: 'لم يتم الضبط' },
    na: { id: 'Tidak Ada', ar: 'غير متوفر' },
    programFallback: { id: 'Program', ar: 'البرنامج' },
    generalFallback: { id: 'Umum', ar: 'عام' },
    registrationStatus: {
      PENDING: { id: 'Menunggu Verifikasi', ar: 'قيد الانتظار' },
      APPROVED: { id: 'Disetujui', ar: 'مقبول' },
      REJECTED: { id: 'Ditolak', ar: 'مرفوض' },
      REVISION: { id: 'Perlu Revisi', ar: 'بحاجة للمراجعة' },
      CANCELLED: { id: 'Dibatalkan', ar: 'ملغي' },
    },
    enrollmentStatus: {
      ACTIVE: { id: 'Aktif', ar: 'نشط' },
      COMPLETED: { id: 'Selesai', ar: 'مكتمل' },
    },
    downloadReceipt: { id: 'Unduh Bukti Pendaftaran', ar: 'تنزيل إيصال التسجيل' },
    changePasswordSuccess: { id: 'Password berhasil diubah!', ar: 'تم تغيير كلمة المرور بنجاح!' },
  },
  participantBackground: {
    occupationLabel: { id: 'Pekerjaan', ar: 'العمل' },
    occupationHelp: {
      id: 'Pilih pekerjaan saat ini. Pilih “Lainnya” bila belum tersedia.',
      ar: 'اختر عملك الحالي. اختر «أخرى» إن لم يكن متاحاً.',
    },
    occupationOtherLabel: { id: 'Pekerjaan lainnya', ar: 'عمل آخر' },
    occupationOtherPlaceholder: { id: 'Tulis pekerjaan Anda', ar: 'اكتب عملك' },
    educationLabel: { id: 'Pendidikan terakhir', ar: 'آخر مؤهل تعليمي' },
    educationHelp: {
      id: 'Pilih jenjang pendidikan terakhir yang telah atau sedang ditempuh.',
      ar: 'اختر آخر مرحلة تعليمية أتممتها أو تدرسها حالياً.',
    },
    educationOtherLabel: { id: 'Pendidikan lainnya', ar: 'مؤهل تعليمي آخر' },
    educationOtherPlaceholder: { id: 'Tulis pendidikan terakhir Anda', ar: 'اكتب آخر مؤهل تعليمي' },
    chooseOccupation: { id: 'Pilih pekerjaan', ar: 'اختر العمل' },
    chooseEducation: { id: 'Pilih pendidikan terakhir', ar: 'اختر آخر مؤهل تعليمي' },
    options: {
      STUDENT: { id: 'Pelajar / Mahasiswa', ar: 'طالب / طالبة' },
      TEACHER: { id: 'Pendidik', ar: 'معلّم / معلّمة' },
      PRIVATE_EMPLOYEE: { id: 'Karyawan swasta', ar: 'موظف قطاع خاص' },
      CIVIL_SERVANT: { id: 'ASN / PNS', ar: 'موظف حكومي' },
      ENTREPRENEUR: { id: 'Wirausaha', ar: 'رائد أعمال' },
      HOMEMAKER: { id: 'Ibu rumah tangga', ar: 'ربة منزل' },
      HEALTHCARE_PROFESSIONAL: { id: 'Tenaga kesehatan', ar: 'ممارس صحي' },
      NOT_CURRENTLY_WORKING: { id: 'Belum / tidak sedang bekerja', ar: 'لا أعمل حالياً' },
      NO_FORMAL_EDUCATION: { id: 'Belum / tidak ada pendidikan formal', ar: 'لا تعليم نظامي' },
      PRIMARY: { id: 'SD / sederajat', ar: 'ابتدائي أو ما يعادله' },
      JUNIOR_SECONDARY: { id: 'SMP / sederajat', ar: 'متوسط أو ما يعادله' },
      SENIOR_SECONDARY: { id: 'SMA / SMK / sederajat', ar: 'ثانوي أو ما يعادله' },
      DIPLOMA: { id: 'Diploma', ar: 'دبلوم' },
      BACHELOR: { id: 'S1 / Sarjana', ar: 'بكالوريوس' },
      MASTER: { id: 'S2 / Magister', ar: 'ماجستير' },
      DOCTORAL: { id: 'S3 / Doktor', ar: 'دكتوراه' },
      OTHER: { id: 'Lainnya (tulis sendiri)', ar: 'أخرى (اكتبها)' },
    },
  },
  shell: {
    dashboard: { id: 'Dashboard', ar: 'لوحة القيادة' },
    myPrograms: { id: 'Program Saya', ar: 'برامجي' },
    results: { id: 'Hasil Belajar', ar: 'النتائج' },
    logout: { id: 'Keluar', ar: 'تسجيل الخروج' },
    profile: { id: 'Profil', ar: 'الملف الشخصي' },
    notifications: { id: 'Notifikasi', ar: 'الإشعارات' },
    student: { id: 'Peserta', ar: 'مشارك' },
    transcripts: { id: 'Transkrip v3', ar: 'كشف درجات v3' },
    legacyTranscripts: { id: 'Riwayat', ar: 'الأرشيف' },
    more: { id: 'Lainnya', ar: 'المزيد' },
    certificates: { id: 'Syahadah', ar: 'الشهادات' },
    announcements: { id: 'Pengumuman', ar: 'الإعلانات' },
  },
  announcements: {
    title: { id: 'Pengumuman & Informasi', ar: 'الإعلانات والمعلومات' },
    subtitle: {
      id: 'Informasi akademik terkini, jadwal kegiatan, dan pengumuman penting.',
      ar: 'آخر المعلومات الأكاديمية وجداول الفعاليات والإعلانات الهامة.',
    },
    latestAnnouncements: { id: 'Pengumuman & Informasi', ar: 'الإعلانات والبيانات' },
    urgentNotice: { id: 'PENGUMUMAN PENTING', ar: 'تنبيه عاجل' },
    readMore: { id: 'Baca Selengkapnya', ar: 'قراءة المزيد' },
    viewAll: { id: 'Lihat Semua Pengumuman', ar: 'عرض جميع الإعلانات' },
    dismissBanner: { id: 'Tutup Pengumuman', ar: 'إغلاق الإشعار' },
    dismissNotice: { id: 'Tutup Pengumuman', ar: 'إغلاق الإشعار' },
    noAnnouncements: { id: 'Belum ada pengumuman saat ini.', ar: 'لا توجد إعلانات حالياً.' },
    notificationsTitle: { id: 'Pemberitahuan & Siaran', ar: 'الإشعارات والإعلانات' },
    noNotifications: { id: 'Tidak ada pengumuman baru.', ar: 'لا توجد إعلانات جديدة حالياً.' },
    catGeneral: { id: 'Umum', ar: 'عام' },
    catAcademic: { id: 'Akademik', ar: 'أكاديمي' },
    catMaintenance: { id: 'Pemeliharaan', ar: 'صيانة' },
    catImportant: { id: 'Penting', ar: 'هام' },
    catEvent: { id: 'Kegiatan', ar: 'فعالية' },
    prioNormal: { id: 'Normal', ar: 'عادي' },
    prioHigh: { id: 'Tinggi', ar: 'مرتفع' },
    prioUrgent: { id: 'Mendesak', ar: 'عاجل' },
  },
  // Bilingual copy shown by the `LogoutReasonBanner` component on the
  // login / reset-password / verify-email screens when a 401 reason has
  // been stashed into sessionStorage by the api-client's `on401`
  // handler. Keys must match `LogoutReasonKey` in
  // `../lib/logout-reason.ts`.
  loginBanner: {
    account_inactive: {
      id: 'Akun Anda tidak aktif. Silakan hubungi admin untuk mengaktifkannya kembali.',
      ar: 'حسابك غير نشط. يرجى التواصل مع المسؤول لإعادة التفعيل.',
    },
    token_invalid: {
      id: 'Sesi Anda tidak valid. Silakan masuk kembali.',
      ar: 'جلستك غير صالحة. يرجى تسجيل الدخول مرة أخرى.',
    },
    session_expired: {
      id: 'Sesi Anda telah berakhir. Silakan masuk kembali untuk melanjutkan.',
      ar: 'انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى للمتابعة.',
    },
    idle_timeout: {
      id: 'Sesi Anda telah berakhir otomatis karena tidak ada aktivitas untuk menghemat sumber daya server. Silakan masuk kembali.',
      ar: 'انتهت صلاحية جلستك تلقائيًا بسبب عدم وجود نشاط لتوفير موارد الخادم. يرجى تسجيل الدخول مرة أخرى.',
    },
    unknown: {
      id: 'Anda telah keluar dari sesi. Silakan masuk kembali untuk melanjutkan.',
      ar: 'تم تسجيل خروجك. يرجى تسجيل الدخول مرة أخرى للمتابعة.',
    },
  },
  login: {
    title: {
      id: "Assalamu'alaikum, siap untuk belajar?",
      ar: 'السلام عليكم، هل أنت مستعد للتعلم؟',
    },
    subtitle: {
      id: 'Akses portal peserta untuk mengelola program belajar dan memantau kemajuan Anda.',
      ar: 'الدخول إلى بوابة المشاركين لإدارة البرامج الدراسية ومتابعة تقدمك.',
    },
    resetTitle: { id: 'Reset Kata Sandi Anda', ar: 'إعادة تعيين كلمة المرور' },
    resetSubtitle: {
      id: 'Masukkan email Anda untuk menerima tautan pemulihan.',
      ar: 'أدخل بريدك الإلكتروني لتلقي رابط الاسترداد.',
    },
    emailLabel: { id: 'Alamat Email', ar: 'البريد الإلكتروني' },
    emailPlaceholder: { id: 'peserta@tslearning.com', ar: 'student@tslearning.com' },
    emailInvalid: {
      id: 'Masukkan alamat email yang valid.',
      ar: 'أدخل عنوان بريد إلكتروني صالحًا.',
    },
    identifierRequired: {
      id: 'Email, NIP, atau nomor HP wajib diisi.',
      ar: 'البريد أو الرقم الأكاديمي أو رقم الهاتف مطلوب.',
    },
    passwordRequired: { id: 'Kata sandi wajib diisi.', ar: 'كلمة المرور مطلوبة.' },
    passwordLabel: { id: 'Kata Sandi', ar: 'كلمة المرور' },
    passwordPlaceholder: { id: '••••••••', ar: '••••••••' },
    identifierLabel: { id: 'Email / NIP / No. HP', ar: 'البريد / الرقم الوظيفي / الهاتف' },
    identifierPlaceholder: {
      id: 'email@domain.com, 1985xxxx, atau 0812...',
      ar: 'email@domain.com، 1985xxxx، أو 0812...',
    },
    forgotLabel: { id: 'Lupa Kata Sandi?', ar: 'نسيت كلمة المرور؟' },
    sendLink: { id: 'Kirim Tautan Pemulihan', ar: 'إرسال رابط الاسترداد' },
    signInBtn: { id: 'Masuk ke Portal', ar: 'تسجيل الدخول إلى البوابة' },
    backToLogin: { id: 'Kembali ke Halaman Masuk', ar: 'العودة إلى تسجيل الدخول' },
    heroTitle: {
      id: 'Tuntutlah Ilmu dengan Keikhlasan dan Keistiqomahan.',
      ar: 'اطلب العلم بإخلاص وتميز.',
    },
    heroText: {
      id: 'Melanjutkan perjalanan menuntut ilmu Anda. Platform kami menyediakan sarana dan komunitas untuk pemahaman yang mendalam dan pertumbuhan keimanan.',
      ar: 'واصل رحلتك التعليمية. توفر منصتنا الأدوات والمجتمع للفهم العميق والنمو الروحي.',
    },
    heroStats: {
      id: 'Gabung bersama 5.000+ peserta aktif di seluruh dunia.',
      ar: 'انضم إلى أكثر من 5000 مشارك نشط حول العالم.',
    },
    linkSentSuccess: {
      id: 'Tautan reset kata sandi telah dikirim ke email Anda.',
      ar: 'تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.',
    },
    authFailed: {
      id: 'Autentikasi gagal. Silakan periksa kembali email dan kata sandi Anda.',
      ar: 'فشلت عملية المصادقة. يرجى التحقق من البريد الإلكتروني وكلمة المرور.',
    },
    tooManyAttempts: {
      id: 'Terlalu banyak percobaan untuk akun ini. Tunggu satu menit, lalu coba kembali.',
      ar: 'هناك محاولات كثيرة لهذا الحساب. انتظر دقيقة واحدة ثم حاول مرة أخرى.',
    },
    migrationVerificationRequired: {
      id: 'Akun Anda telah dipindahkan ke sistem login baru. Periksa email untuk verifikasi, lalu masuk kembali.',
      ar: 'تم نقل حسابك إلى نظام تسجيل الدخول الجديد. يرجى التحقق من بريدك الإلكتروني ثم تسجيل الدخول مرة أخرى.',
    },
  },
  signup: {
    title: { id: 'Mulai Menuntut Ilmu', ar: 'ابدأ رحلتك التعليمية' },
    subtitle: {
      id: 'Buat akun peserta baru untuk bergabung dengan program Belajar Islam Dasar (BID).',
      ar: 'أنشئ حساب مشارك جديد للانضمام إلى برنامج تعليم الإسلام الأساسي.',
    },
    nameLabel: { id: 'Nama Lengkap', ar: 'الاسم الكامل' },
    namePlaceholder: { id: 'Contoh: Ahmad', ar: 'مثال: أحمد' },
    emailLabel: { id: 'Alamat Email', ar: 'البريد الإلكتروني' },
    emailPlaceholder: { id: 'peserta@tslearning.com', ar: 'student@tslearning.com' },
    phoneLabel: { id: 'Nomor Telepon (WhatsApp)', ar: 'رقم الهاتف (الواتساب)' },
    phonePlaceholder: {
      id: 'Contoh: 08123456789 atau +60123456789',
      ar: 'مثال: 08123456789 أو +60123456789',
    },
    phoneHelp: {
      id: 'Nomor Indonesia dapat memakai 08…; nomor luar negeri wajib memakai +kode negara.',
      ar: 'يمكن للأرقام الإندونيسية استخدام 08…؛ ويجب أن تتضمن الأرقام الدولية +رمز الدولة.',
    },
    dateOfBirthLabel: { id: 'Tanggal Lahir', ar: 'تاريخ الميلاد' },
    ageSummary: { id: 'Usia saat ini: {age} tahun', ar: 'العمر الحالي: {age} سنة' },
    genderLabel: { id: 'Jenis Kelamin', ar: 'الجنس' },
    genderMale: { id: 'Ikhwan (Laki-laki)', ar: 'إخوان (ذكر)' },
    genderFemale: { id: 'Akhwat (Perempuan)', ar: 'أخوات (أنثى)' },
    passwordLabel: { id: 'Kata Sandi', ar: 'كلمة المرور' },
    passwordPlaceholder: { id: '••••••••', ar: '••••••••' },
    passwordHelp: {
      id: 'Minimal 8 karakter. Gunakan kombinasi huruf dan angka agar lebih aman.',
      ar: '8 أحرف على الأقل. استخدم مزيجًا من الحروف والأرقام لمزيد من الأمان.',
    },
    confirmPasswordLabel: { id: 'Konfirmasi Kata Sandi', ar: 'تأكيد كلمة المرور' },
    signupBtn: { id: 'Daftar Akun', ar: 'تسجيل الحساب' },
    alreadyRegistered: { id: 'Sudah memiliki akun?', ar: 'هل لديك حساب بالفعل؟' },
    loginBtn: { id: 'Masuk ke akun', ar: 'تسجيل الدخول' },
    successMsg: {
      id: 'Registrasi berhasil! Silakan masuk dengan akun baru Anda.',
      ar: 'تم التسجيل بنجاح! يرجى تسجيل الدخول بحسابك الجديد.',
    },
    errorMsg: { id: 'Gagal melakukan registrasi.', ar: 'فشل التسجيل.' },
    heroTitleStart: { id: 'Mulai Perjalanan', ar: 'ابدأ مسيرتك' },
    heroTitleEnd: { id: 'Keilmuan Anda', ar: 'العلمية' },
    heroSubtitle: {
      id: 'Bergabunglah dengan komunitas pencari ilmu global yang didedikasikan untuk pengetahuan otentik dan kemurnian keimanan.',
      ar: 'انضم إلى مجتمع عالمي من الباحثين عن العلم المكرسين للمعرفة الأصيلة والصفاء الروحي.',
    },
    features: {
      curriculum: { id: 'Kurikulum Otentik', ar: 'منهج دراسي أصيل' },
      track: { id: 'Jalur Belajar Terstruktur', ar: 'مسارات تعليمية منظمة' },
      community: { id: 'Akses Komunitas Global', ar: 'الوصول إلى مجتمع عالمي' },
      progress: { id: 'Pelacakan Kemajuan Pribadi', ar: 'متابعة التقدم الشخصي' },
    },
    errors: {
      nameMin: { id: 'Nama minimal harus 2 karakter', ar: 'الاسم يجب أن يكون حرفين على الأقل' },
      emailInvalid: { id: 'Format email tidak valid', ar: 'البريد الإلكتروني غير صالح' },
      phoneInvalid: {
        id: 'Masukkan nomor WhatsApp yang valid: 08… atau +kode negara, misalnya +60123456789.',
        ar: 'أدخل رقم واتساب صحيحًا: 08… أو +رمز الدولة، مثل +60123456789.',
      },
      dateOfBirthRequired: {
        id: 'Tanggal lahir wajib diisi',
        ar: 'تاريخ الميلاد مطلوب',
      },
      dateOfBirthInvalid: {
        id: 'Masukkan tanggal lahir yang valid dan telah berlalu',
        ar: 'أدخل تاريخ ميلاد صحيحًا وقد مضى',
      },
      fieldRequired: {
        id: 'Pilih salah satu opsi atau isi keterangan lainnya.',
        ar: 'اختر أحد الخيارات أو املأ الوصف الآخر.',
      },
      passwordMin: {
        id: 'Kata sandi minimal harus 8 karakter',
        ar: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل',
      },
      confirmPasswordMin: {
        id: 'Konfirmasi kata sandi minimal harus 8 karakter',
        ar: 'تأكيد كلمة المرور يجب أن يكون 8 أحرف على الأقل',
      },
      passwordsDontMatch: { id: 'Kata sandi tidak cocok', ar: 'كلمة المرور غير متطابقة' },
    },
  },
  verifyEmail: {
    loadingTitle: { id: 'Memverifikasi Email...', ar: 'جاري التحقق من البريد الإلكتروني...' },
    loadingDesc: {
      id: 'Mohon tunggu sebentar, kami sedang memverifikasi token Anda.',
      ar: 'يرجى الانتظار لحظة، نحن نتحقق من الرمز الخاص بك.',
    },
    successTitle: { id: 'Email Terverifikasi!', ar: 'تم التحقق من البريد الإلكتروني!' },
    successDesc: {
      id: 'Email Anda berhasil diverifikasi. Silakan login untuk mulai belajar.',
      ar: 'تم التحقق من بريدك الإلكتروني بنجاح. يرجى تسجيل الدخول لبدء التعلم.',
    },
    successBtn: { id: 'Lanjutkan ke Login', ar: 'المتابعة إلى تسجيل الدخول' },
    failedTitle: { id: 'Verifikasi Gagal', ar: 'فشل التحقق' },
    backToLogin: { id: 'Kembali ke Login', ar: 'العودة إلى تسجيل الدخول' },
    tokenNotFound: { id: 'Token verifikasi tidak ditemukan.', ar: 'لم يتم العثور على رمز التحقق.' },
    generalError: { id: 'Verifikasi email gagal.', ar: 'فشل التحقق من البريد الإلكتروني.' },
  },
  resetPassword: {
    invalidTokenTitle: { id: 'Token Tidak Valid', ar: 'رمز غير صالح' },
    invalidTokenDesc: {
      id: 'Link reset password tidak lengkap atau tidak valid. Silakan minta link baru di halaman login.',
      ar: 'رابط إعادة تعيين كلمة المرور غير مكتمل أو غير صالح. يرجى طلب رابط جديد من صفحة تسجيل الدخول.',
    },
    backToLogin: { id: 'Kembali ke Login', ar: 'العودة إلى تسجيل الدخول' },
    tokenNotFound: {
      id: 'Token reset password tidak ditemukan.',
      ar: 'لم يتم العثور على رمز إعادة تعيين كلمة المرور.',
    },
    generalError: { id: 'Gagal mereset password.', ar: 'فشل إعادة تعيين كلمة المرور.' },
    successTitle: { id: 'Password Diperbarui', ar: 'تم تحديث كلمة المرور' },
    successDesc: {
      id: 'Password Anda telah berhasil diubah. Silakan login kembali dengan password baru Anda.',
      ar: 'تم تغيير كلمة المرور الخاصة بك بنجاح. يرجى تسجيل الدخول مرة أخرى باستخدام كلمة المرور الجديدة.',
    },
    title: { id: 'Buat Password Baru', ar: 'إنشاء كلمة مرور جديدة' },
    subtitle: {
      id: 'Masukkan password baru Anda untuk akun Tarbiyah Sunnah Learning.',
      ar: 'أدخل كلمة المرور الجديدة لحساب Tarbiyah Sunnah Learning الخاص بك.',
    },
    newPasswordLabel: { id: 'Password Baru', ar: 'كلمة المرور الجديدة' },
    newPasswordPlaceholder: { id: 'Minimal 8 karakter', ar: 'على الأقل 8 أحرف' },
    confirmPasswordLabel: { id: 'Konfirmasi Password Baru', ar: 'تأكيد كلمة المرور الجديدة' },
    confirmPasswordPlaceholder: { id: 'Ulangi password baru', ar: 'كرر كلمة المرور الجديدة' },
    submitBtn: { id: 'Simpan Password', ar: 'حفظ كلمة المرور' },
    validation: {
      passwordMin: {
        id: 'Password minimal 8 karakter',
        ar: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل',
      },
      confirmPasswordMin: {
        id: 'Konfirmasi password minimal 8 karakter',
        ar: 'تأكيد كلمة المرور يجب أن يكون 8 أحرف على الأقل',
      },
      passwordsDontMatch: { id: 'Password tidak cocok', ar: 'كلمة المرور غير متطابقة' },
    },
  },
  dashboard: {
    gatheringProgress: {
      id: 'Mengumpulkan perkembangan belajar Anda...',
      ar: 'جاري جمع تقدمك الدراسي...',
    },
    welcome: { id: "Assalamu'alaikum", ar: 'السلام عليكم' },
    readyToContinue: { id: 'Siap untuk melanjutkan?', ar: 'هل أنت مستعد للمتابعة؟' },
    learningHub: { id: 'Pusat Aktivitas Belajar', ar: 'مركز أنشطة التعلم' },
    quickAccess: { id: 'Akses cepat', ar: 'الوصول السريع' },
    liveSessionLabel: { id: 'Sesi tatap muka', ar: 'جلسة مباشرة' },
    liveSessionsTitle: { id: 'Tatap Muka Online', ar: 'اللقاءات المباشرة عبر الإنترنت' },
    openMaterial: { id: 'Buka materi', ar: 'فتح المادة' },
    joinLiveSession: { id: 'Gabung tatap muka', ar: 'الانضمام إلى اللقاء' },
    continueLearning: { id: 'Lanjutkan Belajar', ar: 'مواصلة التعلم' },
    nextMilestone: { id: 'Pencapaian Berikutnya', ar: 'المرحلة التالية' },
    browsePrograms: { id: 'Telusuri Program', ar: 'تصفح البرامج' },
    overallProgress: { id: 'Kemajuan Keseluruhan', ar: 'التقدم العام' },
    myPrograms: { id: 'Program Saya', ar: 'برامجي' },
    viewAll: { id: 'Lihat Semua', ar: 'عرض الكل' },
    noEnrollments: {
      id: 'Anda belum terdaftar dalam program apa pun saat ini.',
      ar: 'لم يتم تسجيلك في أي برامج بعد.',
    },
    aiInsights: { id: 'Analisis Belajar', ar: 'تحليلات التعلم' },
    recentActivityTitle: {
      id: '{count} materi selesai dalam 7 hari terakhir',
      ar: 'تم إكمال {count} مادة خلال آخر 7 أيام',
    },
    resumeRhythmTitle: {
      id: 'Saatnya kembali ke ritme belajar Anda',
      ar: 'حان الوقت للعودة إلى وتيرة تعلمك',
    },
    observedStudyTime: {
      id: 'Aktivitas belajar Anda paling sering tercatat pada {timeOfDay} hari, sekitar jam {hour}.',
      ar: 'يتم تسجيل نشاطك التعليمي غالباً في الفترة {timeOfDayAr}، حوالي الساعة {hourAr}.',
    },
    progressShort: { id: 'Progres', ar: 'التقدم' },
    activeProgramsShort: { id: 'Program aktif', ar: 'البرامج النشطة' },
    lastSevenDaysShort: { id: 'Selesai 7 hari', ar: 'مكتمل في 7 أيام' },
    learningSummary: { id: 'Ringkasan aktivitas belajar', ar: 'ملخص نشاط التعلم' },
    viewProgress: { id: 'Lihat progres', ar: 'عرض التقدم' },
    viewPrograms: { id: 'Lihat program', ar: 'عرض البرامج' },
    viewActivity: { id: 'Buka materi', ar: 'فتح المواد' },
    openNextStep: { id: 'Buka langkah berikutnya', ar: 'فتح الخطوة التالية' },
    activeStudyDays: {
      id: 'Hari belajar aktif dalam 7 hari terakhir',
      ar: 'أيام التعلم النشطة خلال آخر 7 أيام',
    },
    programCollection: { id: 'Koleksi pembelajaran', ar: 'مجموعة التعلم' },
    featuredProgram: { id: 'Program utama Anda', ar: 'برنامجك الرئيسي' },
    openProgram: { id: 'Lihat alur program', ar: 'عرض مسار البرنامج' },
    aiInsightsStartTitle: {
      id: 'Ayo mulai langkah pertama belajar Anda hari ini!',
      ar: 'لنبدأ الخطوة الأولى في تعلمك اليوم!',
    },
    aiInsightsDescFallback: {
      id: 'Belajar secara konsisten meskipun sedikit akan memberikan dampak besar. Mulailah mempelajari materi pertama Anda di portal.',
      ar: 'التعلم المستمر وإن كان قليلاً له أثر كبير. ابدأ بدراسة أول درس لك في البوابة.',
    },
    dayAbbreviations: [
      { id: 'M', ar: 'ح' },
      { id: 'S', ar: 'ن' },
      { id: 'S', ar: 'ث' },
      { id: 'R', ar: 'ر' },
      { id: 'K', ar: 'خ' },
      { id: 'J', ar: 'ج' },
      { id: 'S', ar: 'س' },
    ],
    pendingEvaluationsAlertTitle: {
      id: 'Evaluasi & Ujian Siap Dikerjakan',
      ar: 'اختبارات وتقييمات بانتظارك',
    },
    pendingEvaluationsAlertDesc: {
      id: 'Terdapat evaluasi pembelajaran yang belum diselesaikan. Mari tuntaskan evaluasi ini untuk melanjutkan ke tahap berikutnya.',
      ar: 'لديك تقييمات لم تكتمل بعد. يرجى إنجازها للمتابعة إلى المرحلة التالية.',
    },
    inactivityNoticeTitle: {
      id: 'Mari Lanjutkan Semangat Menuntut Ilmu',
      ar: 'واصل رحلتك المباركة في طلب العلم',
    },
    inactivityNoticeDesc: {
      id: 'Sudah beberapa hari belum melanjutkan materi. Sedikit demi sedikit namun istiqamah adalah kunci keberkahan ilmu.',
      ar: 'مرت عدة أيام منذ آخر نشاط. الاستمرار في طلب العلم ولو بالقليل هو مفتاح البركة.',
    },
    actionTakeExam: { id: 'Kerjakan Ujian Tertunda', ar: 'أداء الاختبار المعلق' },
    actionResumeStudy: { id: 'Lanjutkan Materi Belajar', ar: 'متابعة الدرس الأخير' },
    pendingCountBadge: { id: 'Ujian Menunggu', ar: 'اختبار معلق' },
    actionRequired: { id: 'Perlu Tindakan', ar: 'مهام مطلوبة' },
    queue: { id: 'Antrean', ar: 'الطابور' },
    allUpToDate: {
      id: 'Semua alur pembelajaran Anda telah diperbarui dan tuntas.',
      ar: 'جميع مسارات التعلم محدثة ومكتملة.',
    },
    onboardingChecklist: { id: 'Daftar Periksa Onboarding', ar: 'قائمة التهيئة والتهضيم' },
    scholarIdentifier: { id: 'Nomor Induk Peserta', ar: 'رقم تعريف المشارك' },
    noPending: { id: 'Tidak ada aplikasi tertunda.', ar: 'لا توجد طلبات معلقة.' },
    registrationOnboarding: { id: 'Pendaftaran & Onboarding', ar: 'التسجيل والتهيئة' },
    waStep: { id: 'Grup WhatsApp', ar: 'مجموعة الواتساب' },
    profileStep: { id: 'Lengkapi Profil', ar: 'إكمال الملف الشخصي' },
    consentStep: { id: 'Protokol Digital', ar: 'الموافقة الرقمية' },
    orientationStep: { id: 'Materi Orientasi', ar: 'المواد التوجيهية' },
    downloadReceipt: { id: 'Unduh Bukti Pendaftaran', ar: 'تنزيل إيصال التسجيل' },
  },
  programs: {
    syncingPath: {
      id: 'Menyelaraskan dengan alur pembelajaran...',
      ar: 'جاري المزامنة مع مسار التعلم...',
    },
    journeyTitle: { id: 'Perjalanan Belajar', ar: 'مسيرة التعلم' },
    journeySubtitle: {
      id: 'Tingkatkan ilmu Anda, perbaiki akhlak, dan terhubunglah dengan warisan ketakwaan.',
      ar: 'وسع معرفتك، وحسن أخلاقك، وتواصل مع تراث التقوى.',
    },
    myProgramsTab: { id: 'Program Saya', ar: 'برامجي' },
    exploreTab: { id: 'Jelajahi', ar: 'استكشاف' },
    ongoing: { id: 'Sedang Berjalan', ar: 'قيد التنفيذ' },
    progress: { id: 'Kemajuan', ar: 'التقدم' },
    activePrograms: { id: 'Program aktif', ar: 'البرامج النشطة' },
    pendingApplications: { id: 'Pendaftaran diproses', ar: 'التسجيلات قيد المعالجة' },
    noEnrollmentsTitle: { id: 'Belum ada pendaftaran aktif', ar: 'لا توجد تسجيلات نشطة' },
    noEnrollmentsDesc: {
      id: 'Anda belum bergabung dengan program apa pun. Jelajahi program kami untuk menemukan jalur belajar Anda.',
      ar: 'لم تنضم إلى أي برامج بعد. تصفح عروضنا للعثور على المسار المناسب لك.',
    },
    exploreProgramsBtn: { id: 'Jelajahi Program', ar: 'استكشاف البرامج' },
    enrollNow: { id: 'Daftar Sekarang', ar: 'سجل الآن' },
    regClosed: { id: 'Pendaftaran Ditutup', ar: 'التسجيل مغلق' },
    checkLater: {
      id: 'Silakan periksa kembali nanti untuk program-program baru.',
      ar: 'يرجى التحقق لاحقاً من وجود برامج جديدة.',
    },
    // MY-tab label for the timestamp under a pending / non-approved
    // registration card ("Terdaftar pada" / "تاريخ التسجيل").
    submittedOn: { id: 'Terdaftar pada', ar: 'تاريخ التسجيل' },
    // MY-tab label for the SECOND timestamp row that appears under
    // submittedOn when the row has been re-submitted at least once
    // (i.e. registration.lastResubmittedAt is set). Backed by the
    // `lastResubmittedAt` column on ProgramRegistration.
    resubmittedOn: { id: 'Diajukan ulang pada', ar: 'أُعيد تقديمه في' },
    // CTA label rendered on the bottom of a REJECTED / REVISION /
    // CANCELLED registration card in the MY tab. Deep-links to the
    // Registration form for the same program so the user can re-submit
    // in one click instead of navigating through the program detail.
    viewDetailCta: { id: 'Lihat Detail Pendaftaran', ar: 'عرض تفاصيل التسجيل' },
  },
  registration: {
    detailTitle: { id: 'Detail Program', ar: 'تفاصيل البرنامج' },
    profileTitle: { id: 'Verifikasi Profil', ar: 'التحقق من الملف الشخصي' },
    consentTitle: { id: 'Pernyataan Akhir', ar: 'الموافقة النهائية' },
    preparing: { id: 'Menyiapkan alur pendaftaran...', ar: 'جاري إعداد مسار التسجيل...' },
    regClosedTitle: { id: 'Pendaftaran Ditutup', ar: 'التسجيل مغلق' },
    regClosedDesc: {
      id: 'Masa pendaftaran untuk program {name} telah selesai atau belum dimulai. Silakan cek berkala atau jelajahi program lainnya.',
      ar: 'انتهت فترة التسجيل لبرنامج {name} أو لم تبدأ بعد. يرجى التحقق لاحقاً أو استكشاف برامج أخرى.',
    },
    backToPrograms: { id: 'Kembali ke Program', ar: 'العودة إلى البرامج' },
    backToExplore: { id: 'Kembali ke Jelajah', ar: 'العودة إلى الاستكشاف' },
    confirmingTitle: { id: 'Konfirmasi Partisipasi', ar: 'تأكيد المشاركة' },
    confirmingDesc: {
      id: 'Anda memilih untuk bergabung dalam {name}. Kode program {code} ini mewakili alur pembelajaran yang terstruktur.',
      ar: 'لقد اخترت الانضمام إلى {name}. يمثل رمز البرنامج {code} هذا تسلسلاً تعليمياً منظماً.',
    },
    approvalMode: { id: 'Mode Persetujuan', ar: 'وضع الموافقة' },
    registrationWindow: { id: 'Masa Pendaftaran', ar: 'فترة التسجيل' },
    registrationOpensAt: { id: 'Pendaftaran Dibuka', ar: 'يفتح التسجيل' },
    registrationClosesAt: { id: 'Pendaftaran Ditutup', ar: 'يغلق التسجيل' },
    approvalModeVal: {
      AUTO_APPROVE: { id: 'Otomatis', ar: 'تلقائي' },
      MANUAL: { id: 'Manual (Peninjauan)', ar: 'يدوي (مراجعة)' },
    },
    startDate: { id: 'Tanggal Mulai', ar: 'tatarikh البدء' }, // wait, 'تاريخ البدء'
    nextStep: { id: 'Langkah Berikutnya', ar: 'الخطوة التالية' },
    verifyIdentityTitle: { id: 'Verifikasi Identitas Anda', ar: 'التحقق من هويتك' },
    verifyIdentityDesc: {
      id: 'Harap pastikan detail profil Anda sesuai dengan dokumen resmi Anda. Informasi ini akan digunakan untuk sertifikasi.',
      ar: 'يرجى التأكد من تطابق تفاصيل ملفك الشخصي مع مستنداتك الرسمية. سيتم استخدام هذه المعلومات لإصدار الشهادات.',
    },
    fullName: { id: 'Nama Lengkap', ar: 'الاسم الكامل' },
    emailAddress: { id: 'Alamat Email', ar: 'البريد الإلكتروني' },
    phone: { id: 'Telepon / WhatsApp', ar: 'رقم الهاتف / الواتساب' },
    phoneNotSet: {
      id: 'Tidak tersedia - Perbarui di Profil',
      ar: 'غير متوفر - قم بالتحديث في الملف الشخصي',
    },
    cityLabel: { id: 'Kota Domisili (Sesuai KTP)', ar: 'مدينة الإقامة (وفقاً للبطاقة الشخصية)' },
    cityPlaceholder: {
      id: 'Ketik kabupaten atau kota domisili',
      ar: 'اكتب اسم المنطقة أو المدينة',
    },
    cityDropdownLabel: {
      id: 'Tampilkan saran kabupaten atau kota',
      ar: 'عرض اقتراحات المنطقة أو المدينة',
    },
    cityNoResults: {
      id: 'Tidak ada saran untuk "{query}". Anda tetap dapat menulis domisili sendiri.',
      ar: 'لا توجد اقتراحات لـ "{query}". يمكنك كتابة محل الإقامة يدوياً.',
    },
    reasonLabel: { id: 'Alasan Mengikuti Program', ar: 'سبب الانضمام إلى البرنامج' },
    reasonPlaceholder: {
      id: 'Mengapa Anda tertarik mengikuti program ini?',
      ar: 'لماذا أنت مهتم بالانضمام إلى هذا البرنامج؟',
    },
    cityRequired: {
      id: 'Pilih atau isi kota domisili Anda.',
      ar: 'يرجى اختيار أو إدخال مدينة الإقامة.',
    },
    reasonRequired: {
      id: 'Tuliskan alasan Anda mengikuti program ini.',
      ar: 'يرجى كتابة سبب انضمامك إلى هذا البرنامج.',
    },
    backBtn: { id: 'Kembali', ar: 'السابق' },
    verifyContinueBtn: { id: 'Verifikasi & Lanjutkan', ar: 'التحقق والمتابعة' },
    commitmentTitle: { id: 'Komitmen & Etika', ar: 'الالتزام والأخلاق' },
    commitmentText: {
      id: 'Dengan mendaftar ke program ini, saya mengakui dan menyetujui ketentuan berikut:',
      ar: 'من خلال التسجيل في هذا البرنامج، أقر وأوافق على الشروط التالية:',
    },
    ethics1: {
      id: 'Saya akan menjaga integritas akademik Islam dan perilaku etis sepanjang pembelajaran.',
      ar: 'سوف أحافظ على النزاهة الأكاديمية الإسلامية والسلوك الأخلاقي طوال فترة الدراسة.',
    },
    ethics2: {
      id: 'Saya memahami bahwa perkembangan belajar saya akan dipantau dan ditinjau oleh pengelola.',
      ar: 'أفهم أن تقدمي الدراسي سيكون محل متابعة ومراجعة من sebelum الإدارة.', // wait, 'من قبل الإدارة'
    },
    ethics3: {
      id: 'Saya setuju untuk berpartisipasi dalam evaluasi dan refleksi sesuai yang disyaratkan kurikulum.',
      ar: 'أوافق على المشاركة في التقييمات والتأملات كما يقتضي المنهج الدراسي.',
    },
    ethics4: {
      id: 'Dalam hal persetujuan manual, saya bersedia menunggu proses peninjauan selesai.',
      ar: 'في حالة الموافقة اليدوية، فإنني موافق على الانتظار حتى تكتمل عملية المراجعة.',
    },
    ethicsAccept: {
      id: 'Saya menerima dan menyetujui kebijakan Komitmen & Etika.',
      ar: 'أقبل وأوافق على سياسة الالتزام والأخلاق.',
    },
    additionalNotes: { id: 'Catatan Tambahan (Opsional)', ar: 'ملاحظات إضافية (اختياري)' },
    notesPlaceholder: {
      id: 'Apakah ada hal lain yang perlu kami ketahui?',
      ar: 'هل هناك أي شيء آخر يجب أن نعرفه؟',
    },
    completeEnrollment: { id: 'Selesaikan Pendaftaran', ar: 'إكمال التسجيل' },
    successPendingTitle: {
      id: 'Pendaftaran Berhasil Dikirim!',
      ar: 'تم إرسال التسجيل بنجاح!',
    },
    successPendingDesc: {
      id: 'Jazakumullahu khairan telah mendaftar. Bukti pendaftaran telah dikirim ke email Anda. Tim admin kami sedang memverifikasi data (maksimal 1x24 jam kerja). Tautan grup WhatsApp/Telegram pembelajaran akan dikirimkan otomatis melalui email setelah disetujui.',
      ar: 'جزاكم الله خيراً على التسجيل. تم إرسال إيصال التسجيل إلى بريدك الإلكتروني. يقوم فريق الإشراف بالتحقق من البيانات (خلال ٢٤ ساعة عمل كحد أقصى). سيتم إرسال رابط المجموعة تلقائياً بعد الموافقة.',
    },
    successApprovedTitle: {
      id: 'Selamat, Anda Diterima!',
      ar: 'تهانينا، تم قبولك!',
    },
    successApprovedDesc: {
      id: 'Pendaftaran Anda telah disetujui dan Anda otomatis masuk ke program. Bukti pendaftaran dan tautan grup telah dikirim ke email Anda.',
      ar: 'تمت الموافقة على تسجيلك وانضممت تلقائياً إلى البرنامج. تم إرسال إثبات التسجيل ورابط المجموعة إلى بريدك الإلكتروني.',
    },
    whatsappInvitationTitle: { id: 'Grup Pembelajaran Anda', ar: 'مجموعة التعلم الخاصة بك' },
    whatsappInvitationDesc: {
      id: 'Tautan ini sudah disesuaikan dengan grup belajar yang tersedia.',
      ar: 'تمت مطابقة هذا الرابط مع مجموعة التعلم المتاحة.',
    },
    joinWhatsApp: { id: 'Gabung Grup WhatsApp', ar: 'انضم إلى مجموعة واتساب' },
    groupInvitationPending: {
      id: 'Pendaftaran dan akses belajar Anda tetap aktif. Tautan grup belum tersedia karena grup Akhwat/Ikhwan yang sesuai perlu dilengkapi atau kuotanya penuh. Admin akan mengirim tautan otomatis setelah tersedia.',
      ar: 'تسجيلك ووصولك إلى التعلم لا يزالان نشطين. رابط المجموعة غير متاح بعد لأن مجموعة الإخوة أو الأخوات المناسبة تحتاج إلى الإعداد أو أن سعتها ممتلئة. سيرسل المشرف الرابط تلقائياً عند توفره.',
    },
    groupInvitationRecovering: {
      id: 'Menyiapkan kembali tautan grup Anda…',
      ar: 'جارٍ تجهيز رابط المجموعة الخاص بك مرة أخرى…',
    },
    groupInvitationRecoveryFailed: {
      id: 'Tautan grup belum dapat dipulihkan saat ini. Akses belajar Anda tetap aktif; silakan coba kembali beberapa saat lagi atau hubungi BID Support.',
      ar: 'تعذّر استعادة رابط المجموعة الآن. يظل وصولك إلى التعلم نشطاً؛ يرجى المحاولة لاحقاً أو التواصل مع دعم BID.',
    },
    successRejectedTitle: {
      id: 'Pendaftaran Belum Diterima',
      ar: 'لم يتم قبول التسجيل',
    },
    successRejectedDesc: {
      id: 'Mohon maaf, pendaftaran Anda belum dapat diterima. Hubungi admin untuk informasi lebih lanjut, atau coba lagi dengan data yang berbeda.',
      ar: 'عذراً، لم يتم قبول تسجيلك. يرجى التواصل مع المسؤول لمزيد من المعلومات، أو حاول مرة أخرى ببيانات مختلفة.',
    },
    successRevisionTitle: {
      id: 'Pendaftaran Perlu Revisi',
      ar: 'يحتاج التسجيل إلى مراجعة',
    },
    successRevisionDesc: {
      id: 'Admin meminta Anda untuk merevisi pendaftaran. Silakan cek pesan dari admin dan kirim ulang pendaftaran Anda.',
      ar: 'طلب منك المسؤول مراجعة التسجيل. يرجى التحقق من رسالة المسؤول وإعادة إرسال التسجيل.',
    },
    tryAgainBtn: { id: 'Coba Lagi', ar: 'حاول مرة أخرى' },
    submitErrorTitle: { id: 'Pendaftaran Gagal', ar: 'فشل التسجيل' },
  },
  publicRegistration: {
    eyebrow: { id: 'Pendaftaran Program', ar: 'تسجيل البرنامج' },
    titlePrefix: { id: 'Formulir Pendaftaran', ar: 'استمارة التسجيل' },
    subtitle: {
      id: 'Lengkapi data berikut untuk membuat akun peserta dan mendaftarkan diri ke program ini.',
      ar: 'أكمل البيانات التالية لإنشاء حساب مشارك والتسجيل في هذا البرنامج.',
    },
    accountSection: { id: 'Data Akun Peserta', ar: 'بيانات حساب المشارك' },
    profileSection: { id: 'Data Pendaftaran', ar: 'بيانات التسجيل' },
    programInfo: { id: 'Informasi Program', ar: 'معلومات البرنامج' },
    directEnrollment: { id: 'Masuk otomatis ke program', ar: 'دخول تلقائي إلى البرنامج' },
    manualReview: { id: 'Menunggu peninjauan admin', ar: 'بانتظار مراجعة الإدارة' },
    nipSettingLabel: { id: 'Nomor Induk Peserta (NIP)', ar: 'الرقم الأكاديمي للمشارك' },
    nipGeneratedAutomatically: {
      id: 'Dibuat otomatis bila Anda belum mempunyai NIP',
      ar: 'يُنشأ تلقائياً إذا لم يكن لديك رقم أكاديمي',
    },
    nipNotGenerated: {
      id: 'Tidak dibuat untuk program ini—pendaftaran tetap dapat dilanjutkan',
      ar: 'لن يُنشأ لهذا البرنامج، ويمكن متابعة التسجيل',
    },
    nipFormatHelp: {
      id: 'Format 11 digit: gender, semester masuk, tahun angkatan, dan nomor urut.',
      ar: 'صيغة من ١١ رقماً: الجنس وفصل الدخول وسنة الدفعة والرقم التسلسلي.',
    },
    generatedNipLabel: { id: 'NIP Anda', ar: 'رقمك الأكاديمي' },
    generatedNipHelp: {
      id: 'Simpan nomor ini. NIP dapat digunakan untuk masuk ke portal dan tetap sama saat mengikuti program lain.',
      ar: 'احتفظ بهذا الرقم. يمكن استخدامه للدخول إلى البوابة ويبقى نفسه عند الالتحاق ببرنامج آخر.',
    },
    autoEnrollmentHelp: {
      id: 'Setelah pendaftaran berhasil, Anda langsung diterima dan halaman konfirmasi menampilkan undangan grup WhatsApp sesuai jenis kelamin serta tautan masuk portal peserta.',
      ar: 'بعد نجاح التسجيل، يتم قبولك مباشرة وتعرض صفحة التأكيد دعوة مجموعة واتساب المناسبة لجنسك ورابط الدخول إلى بوابة المشارك.',
    },
    manualReviewHelp: {
      id: 'Setelah formulir terkirim, admin akan meninjau pendaftaran. Undangan grup WhatsApp tersedia setelah disetujui; Anda tetap dapat masuk ke portal untuk melihat status.',
      ar: 'بعد إرسال الاستمارة، تراجع الإدارة التسجيل. تتوفر دعوة مجموعة واتساب بعد الموافقة، ويمكنك الدخول إلى البوابة لمتابعة الحالة.',
    },
    registrationOpen: { id: 'Pendaftaran sedang dibuka', ar: 'التسجيل مفتوح حالياً' },
    registrationClosed: { id: 'Pendaftaran tidak tersedia', ar: 'التسجيل غير متاح' },
    scheduleLabel: { id: 'Periode pendaftaran', ar: 'فترة التسجيل' },
    startDateLabel: { id: 'Program dimulai', ar: 'بداية البرنامج' },
    nameLabel: { id: 'Nama lengkap sesuai identitas', ar: 'الاسم الكامل حسب الهوية' },
    emailLabel: { id: 'Alamat email aktif', ar: 'البريد الإلكتروني النشط' },
    phoneLabel: { id: 'Nomor WhatsApp', ar: 'رقم واتساب' },
    phonePlaceholder: {
      id: 'Contoh: 081234567890 atau +60123456789',
      ar: 'مثال: 081234567890 أو +60123456789',
    },
    phoneHelp: {
      id: 'Nomor Indonesia dapat memakai 08…; nomor luar negeri wajib memakai +kode negara.',
      ar: 'يمكن للأرقام الإندونيسية استخدام 08…؛ ويجب أن تتضمن الأرقام الدولية +رمز الدولة.',
    },
    dateOfBirthLabel: { id: 'Tanggal lahir sesuai identitas', ar: 'تاريخ الميلاد حسب الهوية' },
    ageSummary: { id: 'Usia saat ini: {age} tahun', ar: 'العمر الحالي: {age} سنة' },
    genderLabel: { id: 'Jenis kelamin', ar: 'الجنس' },
    male: { id: 'Laki-laki', ar: 'ذكر' },
    female: { id: 'Perempuan', ar: 'أنثى' },
    passwordLabel: { id: 'Buat kata sandi', ar: 'إنشاء كلمة المرور' },
    confirmPasswordLabel: { id: 'Ulangi kata sandi', ar: 'تأكيد كلمة المرور' },
    passwordHelp: {
      id: 'Minimal 8 karakter. Gunakan kombinasi huruf dan angka agar lebih aman.',
      ar: '8 أحرف على الأقل. استخدم مزيجًا من الحروف والأرقام لمزيد من الأمان.',
    },
    passwordMin: {
      id: 'Kata sandi minimal harus 8 karakter atau lebih.',
      ar: 'يجب أن تتكون كلمة المرور من 8 أحرف أو أكثر.',
    },
    confirmPasswordMin: {
      id: 'Ulangi kata sandi minimal 8 karakter atau lebih.',
      ar: 'يجب أن يتكون تأكيد كلمة المرور من 8 أحرف أو أكثر.',
    },
    cityLabel: { id: 'Kota domisili sesuai KTP', ar: 'مدينة الإقامة حسب الهوية' },
    reasonLabel: { id: 'Alasan mengikuti program', ar: 'سبب الالتحاق بالبرنامج' },
    reasonPlaceholder: {
      id: 'Ceritakan secara singkat alasan Anda mengikuti program ini.',
      ar: 'اذكر بإيجاز سبب رغبتك في الالتحاق بهذا البرنامج.',
    },
    consent: {
      id: 'Saya menyetujui ketentuan pendaftaran dan penggunaan data untuk keperluan pembelajaran.',
      ar: 'أوافق على شروط التسجيل واستخدام البيانات لأغراض التعلم.',
    },
    submit: { id: 'Buat Akun & Daftar Program', ar: 'إنشاء حساب والتسجيل في البرنامج' },
    submitting: { id: 'Memproses pendaftaran...', ar: 'جارٍ معالجة التسجيل...' },
    accountExists: {
      id: 'Email ini sudah memiliki akun. Masuk terlebih dahulu untuk menyelesaikan pendaftaran program ini.',
      ar: 'هذا البريد الإلكتروني لديه حساب بالفعل. سجّل الدخول أولاً لإكمال التسجيل في هذا البرنامج.',
    },
    loginToContinue: { id: 'Masuk & Lanjutkan', ar: 'تسجيل الدخول والمتابعة' },
    successAutoTitle: { id: 'Anda sudah terdaftar di program', ar: 'تم تسجيلك في البرنامج' },
    successAutoDesc: {
      id: 'Pendaftaran Anda berhasil dan akses belajar sudah aktif. Bergabunglah ke grup WhatsApp berikut, lalu masuk ke portal peserta dengan email atau nomor WhatsApp dan kata sandi Anda.',
      ar: 'نجح تسجيلك وأصبح وصولك إلى التعلم نشطًا. انضم إلى مجموعة واتساب التالية، ثم ادخل إلى بوابة المشارك ببريدك الإلكتروني أو رقم واتساب وكلمة مرورك.',
    },
    successManualTitle: { id: 'Formulir pendaftaran terkirim', ar: 'تم إرسال استمارة التسجيل' },
    successManualDesc: {
      id: 'Akun peserta telah dibuat. Tim admin akan meninjau pendaftaran Anda dan mengirimkan hasilnya melalui email.',
      ar: 'تم إنشاء حساب المشارك. سيقوم فريق الإدارة بمراجعة تسجيلك وإرسال النتيجة عبر البريد الإلكتروني.',
    },
    joinGroupNowTitle: {
      id: 'Satu langkah lagi: gabung grup WhatsApp',
      ar: 'خطوة أخيرة: انضم إلى مجموعة واتساب',
    },
    joinGroupNowDesc: {
      id: 'Penting untuk bergabung: informasi pembelajaran selanjutnya, jadwal, dan pengumuman program akan disampaikan melalui grup WhatsApp. Klik tombol di bawah untuk bergabung sekarang.',
      ar: 'من المهم الانضمام: ستُرسل معلومات التعلم القادمة والجداول وإعلانات البرنامج عبر مجموعة واتساب. اضغط الزر أدناه للانضمام الآن.',
    },
    ikhwanGroup: { id: 'Grup Ikhwan (Laki-laki)', ar: 'مجموعة الإخوة (للرجال)' },
    akhwatGroup: { id: 'Grup Akhwat (Perempuan)', ar: 'مجموعة الأخوات (للنساء)' },
    mixedGroup: { id: 'Grup program', ar: 'مجموعة البرنامج' },
    supportHelp: {
      id: 'Lupa bergabung, tautan bermasalah, atau bingung melanjutkan? Hubungi BID Support: 0851-7171-3300.',
      ar: 'نسيت الانضمام أو واجهت مشكلة في الرابط أو لا تعرف الخطوة التالية؟ تواصل مع دعم BID: 0851-7171-3300.',
    },
    networkError: {
      id: 'Koneksi terputus saat memproses pendaftaran. Isian Anda tetap tersedia. Periksa koneksi, lalu tekan Daftar kembali atau hubungi BID Support.',
      ar: 'انقطع الاتصال أثناء معالجة التسجيل. بيانات الاستمارة ما زالت موجودة. تحقق من الاتصال ثم أعد الضغط على التسجيل أو تواصل مع دعم BID.',
    },
    groupLinkPreparingTitle: {
      id: 'Tautan grup sedang disiapkan',
      ar: 'يجري تجهيز رابط المجموعة',
    },
    groupLinkPreparingDesc: {
      id: 'Pendaftaran berhasil dan akses belajar sudah aktif, tetapi tautan grup yang sesuai belum tersedia. Hubungi BID Support di bawah untuk mendapatkan bantuan bergabung.',
      ar: 'نجح التسجيل وأصبح وصولك إلى التعلم نشطًا، لكن رابط المجموعة المناسبة غير متوفر بعد. تواصل مع دعم BID أدناه للمساعدة في الانضمام.',
    },
    pendingReviewTitle: {
      id: 'Menunggu persetujuan pendaftaran',
      ar: 'بانتظار الموافقة على التسجيل',
    },
    pendingReviewDesc: {
      id: 'Tautan grup WhatsApp akan tampil dan dikirim setelah pendaftaran disetujui admin.',
      ar: 'سيظهر رابط مجموعة واتساب ويُرسل بعد موافقة الإدارة على التسجيل.',
    },
    contactBidSupport: { id: 'Butuh bantuan? BID Support', ar: 'تحتاج مساعدة؟ دعم BID' },
    loginAfterVerification: { id: 'Masuk ke Portal Peserta', ar: 'الدخول إلى بوابة المشارك' },
    unavailableTitle: { id: 'Formulir belum tersedia', ar: 'الاستمارة غير متاحة بعد' },
    unavailableDesc: {
      id: 'Pendaftaran program ini sedang ditutup atau belum memasuki periode pendaftaran.',
      ar: 'تسجيل هذا البرنامج مغلق حالياً أو لم تبدأ فترة التسجيل بعد.',
    },
    invalidLinkTitle: { id: 'Tautan pendaftaran tidak ditemukan', ar: 'رابط التسجيل غير موجود' },
    invalidLinkDesc: {
      id: 'Periksa kembali tautan yang Anda terima atau hubungi penyelenggara program.',
      ar: 'تحقق من الرابط الذي تلقيته أو تواصل مع إدارة البرنامج.',
    },
    linkLoadErrorTitle: {
      id: 'Formulir belum dapat dimuat',
      ar: 'تعذر تحميل الاستمارة حالياً',
    },
    linkLoadErrorDesc: {
      id: 'Terjadi gangguan saat memuat formulir. Periksa koneksi Anda, lalu coba kembali.',
      ar: 'حدث خلل أثناء تحميل الاستمارة. تحقّق من اتصالك ثم حاول مرة أخرى.',
    },
    retryLink: { id: 'Coba kembali', ar: 'حاول مرة أخرى' },
    fieldInvalid: { id: 'Lengkapi isian ini dengan benar.', ar: 'يرجى إكمال هذا الحقل بشكل صحيح.' },
    phoneInvalid: {
      id: 'Masukkan nomor WhatsApp yang valid: 08… atau +kode negara, misalnya +60123456789.',
      ar: 'أدخل رقم واتساب صحيحًا: 08… أو +رمز الدولة، مثل +60123456789.',
    },
    dateOfBirthRequired: {
      id: 'Tanggal lahir wajib diisi.',
      ar: 'تاريخ الميلاد مطلوب.',
    },
    dateOfBirthInvalid: {
      id: 'Masukkan tanggal lahir yang valid dan telah berlalu.',
      ar: 'أدخل تاريخ ميلاد صحيحًا وقد مضى.',
    },
    passwordMismatch: {
      id: 'Konfirmasi kata sandi belum sama.',
      ar: 'تأكيد كلمة المرور غير مطابق.',
    },
    consentRequired: {
      id: 'Persetujuan pendaftaran wajib diberikan.',
      ar: 'الموافقة على التسجيل مطلوبة.',
    },
    unexpectedError: {
      id: 'Pendaftaran belum dapat diproses. Silakan coba kembali.',
      ar: 'تعذر إتمام التسجيل حالياً. يرجى المحاولة مرة أخرى.',
    },
  },
  curriculum: {
    ariaLabel: { id: 'Posisi dalam kurikulum', ar: 'الموقع في المنهج' },
    currentPosition: { id: 'Posisi belajar saat ini', ar: 'موضع التعلم الحالي' },
    nextPosition: { id: 'Jalur menuju materi berikutnya', ar: 'المسار إلى المادة التالية' },
    program: { id: 'Program', ar: 'البرنامج' },
    level: { id: 'Level', ar: 'المستوى' },
    stage: { id: 'Tahap / Tema', ar: 'المرحلة / الموضوع' },
    subject: { id: 'Mata pelajaran', ar: 'المادة الدراسية' },
    session: { id: 'Pertemuan', ar: 'اللقاء' },
    material: { id: 'Materi', ar: 'المادة التعليمية' },
    evaluation: { id: 'Ujian', ar: 'الاختبار' },
    curriculumMap: { id: 'Peta kurikulum', ar: 'خريطة المنهج' },
    openSession: { id: 'Buka pertemuan', ar: 'فتح اللقاء' },
    lockedReason: { id: 'Selesaikan prasyarat sebelumnya', ar: 'أكمل المتطلبات السابقة' },
  },
  programDetail: {
    loading: { id: 'Memuat detail program...', ar: 'جاري تحميل تفاصيل البرنامج...' },
    priorLearningRecognized: {
      id: 'Diakui dari nilai pembelajaran sebelumnya',
      ar: 'مُعترف به من نتيجة تعلّم سابقة',
    },
    specialLearningAccess: {
      id: 'Akses belajar khusus diberikan admin untuk mata pelajaran ini. Izin ini tidak memberikan nilai atau kelulusan otomatis.',
      ar: 'منح المشرف صلاحية تعلم خاصة لهذه المادة. لا يمنح هذا الإذن درجات أو نجاحاً تلقائياً.',
    },
    partialLearningAccess: {
      id: 'Aturan umum level belum terpenuhi. Mata pelajaran dengan izin khusus atau pengakuan belajar lama tetap dapat dibuka di bawah ini; pelajaran lainnya tetap mengikuti prasyarat.',
      ar: 'لم تستوف شروط المستوى العامة. يمكن فتح المواد ذات الصلاحية الخاصة أو الاعتراف بالتعلم السابق أدناه، وتبقى المواد الأخرى خاضعة للمتطلبات.',
    },
    archivedLevelContinuation: {
      id: 'Anda dapat melanjutkan belajar pada level ini berdasarkan nilai arsip yang sudah diakui, tanpa mengulang seluruh level sebelumnya. Prasyarat mata pelajaran, urutan materi, dan evaluasi tetap berlaku. Ini bukan kelulusan otomatis.',
      ar: 'يمكنك متابعة التعلم في هذا المستوى بناءً على الدرجات الأرشيفية المعترف بها، دون إعادة جميع المستويات السابقة. تبقى متطلبات المواد وترتيب الدروس والاختبارات سارية. هذا ليس نجاحاً تلقائياً.',
    },
    priorLearningSource: {
      id: 'Pengakuan belajar lama: {score}% dari “{source}”. Materi terkait diakui; Anda dapat melanjutkan sesuai prasyarat berikutnya.',
      ar: 'اعتراف بالتعلم السابق: {score}٪ من «{source}». تم اعتماد المواد ذات الصلة؛ يمكنك المتابعة وفق المتطلبات التالية.',
    },
    priorLearningGradeSource: {
      id: 'Nilai pengakuan belajar lama',
      ar: 'درجة الاعتراف بالتعلم السابق',
    },
    priorLearningEstimated: {
      id: 'Nilai arsip hasil konversi predikat; pengakuan otomatis memakai batas bawah, bukan nilai ujian baru.',
      ar: 'درجة أرشيفية محولة من التقدير؛ يستخدم الاعتراف التلقائي الحد الأدنى، وليست درجة اختبار جديد.',
    },
    completedMaterialsWithCredit: {
      id: 'Termasuk materi yang diakui dari pembelajaran sebelumnya',
      ar: 'تشمل المواد المعترف بها من التعلم السابق',
    },
    accessError: { id: 'Kesalahan Akses Program', ar: 'خطأ في الوصول إلى البرنامج' },
    notEnrolled: {
      id: 'Anda mungkin belum terdaftar di program ini atau program tidak ditemukan.',
      ar: 'قد لا تكون مسجلاً في هذا البرنامج أو أنه غير موجود.',
    },
    backToMyPrograms: { id: 'Kembali ke Program Saya', ar: 'العودة إلى برامجي' },
    progressTitle: { id: 'Kemajuan Belajar Saya', ar: 'تقدمي الدراسي' },
    continueLearning: { id: 'Lanjutkan belajar', ar: 'مواصلة التعلم' },
    nextMaterial: { id: 'Materi berikutnya', ar: 'المادة التالية' },
    allStages: { id: 'Semua tahap', ar: 'جميع المراحل' },
    stageLabel: { id: 'Tahap', ar: 'المرحلة' },
    clearSearch: { id: 'Hapus pencarian', ar: 'مسح البحث' },
    searchPlaceholder: {
      id: 'Cari materi atau nomor pertemuan',
      ar: 'ابحث عن المادة أو رقم اللقاء',
    },
    noMaterials: {
      id: 'Belum ada materi pembelajaran yang tersedia.',
      ar: 'لا توجد مواد تعليمية متاحة بعد.',
    },
    locked: { id: 'Terkunci', ar: 'مغلق' },
    study: { id: 'Pelajari', ar: 'دراسة' },
    quiz: { id: 'Kuis', ar: 'اختبار' },
    passed: { id: 'Lulus', ar: 'ناجح' },
    finalMilestones: { id: 'Pencapaian Akhir', ar: 'المراحل النهائية' },
    assessmentsCompletion: { id: 'Evaluasi & Ketuntasan', ar: 'التقييمات والإكمال' },
    passingScore: { id: 'KKM', ar: 'درجة النجاح' },
    unlockHint: {
      id: 'Selesaikan semua materi untuk membuka',
      ar: 'أكمل جميع المواد لفتح هذا القسم',
    },
    sessionContents: { id: 'Materi & ujian pertemuan', ar: 'مواد واختبارات اللقاء' },
    sessionListTitle: { id: 'Daftar pertemuan', ar: 'قائمة اللقاءات' },
    subjectJumpLabel: { id: 'Lompat ke mata pelajaran', ar: 'انتقل إلى المادة الدراسية' },
    subjectJumpPlaceholder: { id: 'Pilih mata pelajaran', ar: 'اختر المادة الدراسية' },
    subjectSummary: {
      id: '{sessions} pertemuan · {materials} materi',
      ar: '{sessions} لقاء · {materials} مادة',
    },
    expandSubject: { id: 'Buka mata pelajaran', ar: 'فتح المادة الدراسية' },
    collapseSubject: { id: 'Ringkas mata pelajaran', ar: 'طي المادة الدراسية' },
    displayedSessions: {
      id: 'Menampilkan {shown} dari {total} pertemuan',
      ar: 'عرض {shown} من {total} لقاء',
    },
    showMoreSessions: {
      id: 'Tampilkan {count} pertemuan lagi',
      ar: 'عرض {count} لقاء إضافي',
    },
    sessionLockedHint: {
      id: 'Selesaikan prasyarat untuk membuka pertemuan ini.',
      ar: 'أكمل المتطلبات السابقة لفتح هذا اللقاء.',
    },
    closeSession: { id: 'Tutup rincian', ar: 'إغلاق التفاصيل' },
    prerequisiteIncomplete: { id: 'Prasyarat belum tuntas', ar: 'المتطلبات السابقة غير مكتملة' },
    subjectEvaluation: { id: 'Evaluasi Akhir Mata Pelajaran', ar: 'تقييم ختامي للمادة الدراسية' },
    subjectExamLockedHint: {
      id: 'Tuntaskan materi mata pelajaran',
      ar: 'أكمل مواد المادة الدراسية',
    },
    evaluationOnlySession: { id: 'Sesi kuis / ujian', ar: 'جلسة اختبار / امتحان' },
    noSessionContent: { id: 'Belum ada materi atau ujian', ar: 'لا توجد مواد أو اختبارات بعد' },
    openAgain: { id: 'Buka kembali', ar: 'فتح مرة أخرى' },
    startMaterial: { id: 'Mulai materi', ar: 'بدء المادة' },
    examLockedHint: { id: 'Tuntaskan materi pertemuan', ar: 'أكمل مواد اللقاء' },
    evaluationGateBadge: { id: 'Evaluasi wajib lulus', ar: 'يلزم اجتياز التقييم' },
    evaluationGateReason: {
      id: 'Luluskan evaluasi "{evaluation}" dengan nilai minimal {score}% terlebih dahulu.',
      ar: 'اجتز تقييم "{evaluation}" بدرجة لا تقل عن {score}% أولاً.',
    },
    previousMaterialReason: {
      id: 'Selesaikan materi "{material}" terlebih dahulu.',
      ar: 'أكمل المادة "{material}" أولاً.',
    },
    startExam: { id: 'Mulai Ujian', ar: 'بدء الامتحان' },
  },
  materials: {
    title: { id: 'Materi Belajar', ar: 'المواد التعليمية' },
    subtitle: {
      id: 'Kumpulan seluruh materi pembelajaran aktif Anda',
      ar: 'مجموعة من جميع المواد التعليمية النشطة الخاصة بك',
    },
    lastStudied: { id: 'Terakhir Dipelajari', ar: 'آخر ما تم دراسته' },
    continueStudy: { id: 'Lanjutkan Mempelajari', ar: 'مواصلة الدراسة' },
    nextUp: { id: 'Berikutnya untuk dipelajari', ar: 'التالي للدراسة' },
    openMaterial: { id: 'Buka materi', ar: 'فتح المادة' },
    searchPlaceholder: {
      id: 'Cari judul atau deskripsi materi',
      ar: 'البحث في عنوان أو وصف المادة',
    },
    clearSearch: { id: 'Hapus pencarian', ar: 'مسح البحث' },
    viewDetails: { id: 'Lihat Detail', ar: 'عرض التفاصيل' },
    studyBtn: { id: 'Pelajari', ar: 'دراسة' },
    noMaterials: {
      id: 'Belum ada materi belajar yang aktif.',
      ar: 'لا توجد مواد تعليمية نشطة بعد.',
    },
    loadingLibrary: { id: 'Memuat perpustakaan materi...', ar: 'جاري تحميل مكتبة المواد...' },
    loadError: {
      id: 'Materi belum berhasil dimuat. Periksa koneksi lalu coba lagi.',
      ar: 'تعذّر تحميل المواد. تحقق من الاتصال ثم حاول مجددًا.',
    },
    retry: { id: 'Coba lagi', ar: 'حاول مجددًا' },
    materialsCount: {
      id: '{count} materi tersedia di jalur belajar Anda saat ini',
      ar: 'يوجد {count} من المواد المتاحة في مسارك الحالي',
    },
    noMaterialsFound: {
      id: 'Tidak ada materi yang ditemukan dalam kategori ini.',
      ar: 'لم يتم العثور pada مواد في هذه الفئة.',
    }, // wait, 'لم يتم العثور على مواد في هذه الفئة.'
    filters: {
      all: { id: 'Semua', ar: 'الكل' },
      video: { id: 'Video', ar: 'فيديو' },
      audio: { id: 'Audio', ar: 'صوت' },
      document: { id: 'Dokumen', ar: 'مستندات' },
      quiz: { id: 'Kuis', ar: 'اختبارات' },
      completed: { id: 'Selesai', ar: 'مكتمل' },
    },
    types: {
      video: { id: 'Video', ar: 'فيديو' },
      audio: { id: 'Audio', ar: 'صوت' },
      document: { id: 'Dokumen', ar: 'مستند' },
      quiz: { id: 'Kuis', ar: 'اختبار' },
      reflection: { id: 'Refleksi', ar: 'تأمل' },
      discussion: { id: 'Diskusi', ar: 'نقاش' },
    },
  },
  materialDetail: {
    loading: { id: 'Memuat materi...', ar: 'جاري تحميل المادة...' },
    accessError: { id: 'Gagal Memuat Materi', ar: 'فشل في تحميل المادة' },
    completeMark: { id: 'Tandai Selesai', ar: 'تعيين كمكتمل' },
    completed: { id: 'Selesai', ar: 'مكتمل' },
    nextMaterial: { id: 'Materi Selanjutnya', ar: 'المادة التالية' },
    prevMaterial: { id: 'Materi Sebelumnya', ar: 'المادة السابقة' },
    reflectionTab: { id: 'Refleksi', ar: 'تأمل وتلخيص' },
    notesTab: { id: 'Catatan', ar: 'ملاحظات' },
    videoTab: { id: 'Video', ar: 'فيديو' },
    audioTab: { id: 'Audio', ar: 'صوت' },
    backToProgram: { id: 'Kembali ke Alur Program', ar: 'العودة إلى مسار البرنامج' },
    reflectionTitle: { id: 'Tulis Refleksi Belajar Anda', ar: 'اكتب تأملك للمادة' },
    reflectionDesc: {
      id: 'Tuliskan poin penting, pemahaman utama, dan hikmah yang Anda dapatkan dari materi ini sebagai syarat ketuntasan.',
      ar: 'اكتب النقاط الرئيسية، والفهم الأساسي، والحكمة التي اكتسبتها من هذه المادة كشرط للإكمال.',
    },
    reflectionPrompt: {
      id: 'Apa poin penting yang Anda pelajari dari materi ini?',
      ar: 'ما هي النقاط الرئيسية التي استفدتها من هذه المادة؟',
    },
    submitReflection: { id: 'Kirim Refleksi', ar: 'إرسال التأمل' },
    reflectionSaved: { id: 'Refleksi berhasil disimpan.', ar: 'تم حفظ التأمل بنجاح.' },
    submitFeedback: { id: 'Kirim Umpan Balik', ar: 'إرسال الملاحظات' },
    statusAwaiting: { id: 'Menunggu Review Pengajar', ar: 'في انتظار مراجعة المعلم' },
    statusApproved: { id: 'Disetujui', ar: 'مقبول' },
    statusRevision: { id: 'Perlu Revisi', ar: 'بحاجة للمراجعة' },
    lockedTitle: { id: 'Materi Terkunci', ar: 'المادة مغلقة' },
    lockedDesc: {
      id: 'Konten ini terkunci dalam alur pembelajaran sekuensial. Harap selesaikan semua materi sebelumnya sebelum mengakses materi ini.',
      ar: 'هذا المحتوى مغلق ضمن مسار تعليمي متسلسل. يرجى إكمال جميع المواد السابقة قبل الوصول إلى هذا الدرس.',
    },
    backToCurriculum: { id: 'Kembali ke Kurikulum', ar: 'العودة إلى المنهج الدراسي' },
    jumpToContent: { id: 'Lihat media', ar: 'عرض الوسائط' },
    jumpToSummary: { id: 'Baca ringkasan', ar: 'قراءة الملخص' },
    jumpToAttachments: { id: 'Lihat lampiran', ar: 'عرض المرفقات' },
    jumpToAssessments: { id: 'Lihat penilaian', ar: 'عرض التقييمات' },
    jumpToReflection: { id: 'Tulis refleksi', ar: 'كتابة التأمل' },
    learningNavigation: { id: 'Navigasi materi', ar: 'التنقل بين المواد' },
    liveBadge: { id: 'Sesi tatap muka langsung', ar: 'جلسة مباشرة' },
    liveTitle: { id: 'Tatap muka online', ar: 'لقاء مباشر عبر الإنترنت' },
    liveDesc: {
      id: 'Bergabunglah ke ruang diskusi atau kajian bersama pengajar.',
      ar: 'انضم إلى جلسة النقاش أو الدرس مع المعلم.',
    },
    liveJoin: { id: 'Gabung tatap muka', ar: 'الانضمام إلى اللقاء' },
    notFound: { id: 'Materi tidak ditemukan', ar: 'لم يتم العثور على المادة' },
    learned: { id: 'Sudah Dipelajari', ar: 'تم دراستها' },
    milestoneReady: { id: 'Siap Selesai', ar: 'جاهز للإكمال' },
    finishVideo: { id: 'Selesaikan video untuk melanjutkan', ar: 'أكمل الفيديو للمتابعة' },
    listenAudio: { id: 'Dengarkan audio untuk melanjutkan', ar: 'استمع إلى الصوت للمتابعة' },
    completeContent: { id: 'Selesaikan konten untuk melanjutkan', ar: 'أكمل المحتوى للمتابعة' },
    iHaveLearned: { id: 'Saya sudah mempelajari ini', ar: 'لقد درست هذا' },
    completeFailed: {
      id: 'Belum dapat menandai materi selesai. Periksa koneksi atau prasyarat, lalu coba lagi.',
      ar: 'تعذّر إكمال المادة. تحقق من الاتصال أو المتطلبات السابقة ثم حاول مجددًا.',
    },
    reflectionFailed: {
      id: 'Refleksi belum tersimpan. Silakan coba lagi.',
      ar: 'لم يُحفظ التأمل. حاول مرة أخرى.',
    },
    materialContext: { id: 'Konteks Materi', ar: 'سياق المادة' },
    defaultContent: {
      id: 'Materi ini mencakup konsep-konsep inti yang penting untuk perkembangan keimanan dan akademik Anda. Kami menyarankan Anda untuk mencatat saat menonton atau mendengarkan konten.',
      ar: 'تغطي هذه المادة المفاهيم الأساسية الضرورية لتطورك الروحي والأكاديمي. ننصحك بتدوين الملاحظات أثناء المشاهدة أو الاستماع.',
    },
    reflectionLoop: { id: 'Refleksi Belajar', ar: 'حلقة التأمل' },
    reflectionSolidify: {
      id: 'Refleksi membantu memperkuat ingatan dan pemahaman Anda. Anda dapat menuliskan pemikiran Anda di bawah ini.',
      ar: 'يساعد التأمل في ترسيخ معرفتك. يمكنك مشاركة أفكارك أدناه اختياريا.',
    },
    keyTakeaways: {
      id: 'Poin Penting & Rencana Penerapan',
      ar: 'الفوائد الرئيسية والخطط التطبيقية',
    },
    takeawaysPlaceholder: {
      id: 'Apa yang menyentuh hati Anda dalam pelajaran ini? Bagaimana Anda akan menerapkannya hari ini?',
      ar: 'ما الذي أثر فيك في هذا الدرس؟ وكيف ستطبقه اليوم؟',
    },
    characters: { id: 'karakter', ar: 'حرفًا' },
    mentorsOnly: { id: 'Hanya dapat dilihat oleh mentor', ar: 'مرئي للموجهين فقط' },
    curriculumContext: { id: 'Konteks Kurikulum', ar: 'سياق المنهج' },
    estimated: { id: 'Estimasi', ar: 'الوقت المقدر' },
    minRead: { id: 'menit baca', ar: 'دقيقة قراءة' },
    component: { id: 'Komponen', ar: 'المكون' },
    essential: { id: 'Penting', ar: 'أساسي' },
    assessments: { id: 'Penilaian', ar: 'التقييمات' },
    attachments: { id: 'Lampiran & Aset', ar: 'المرفقات والأصول' },
    openAttachment: { id: 'Buka lampiran', ar: 'فتح المرفق' },
    untitledAsset: { id: 'Aset Tanpa Judul', ar: 'أصل بدون عنوان' },
    noteFromAdmin: { id: 'Catatan dari Admin', ar: 'ملاحظة من المسؤول' },
    adminNoteText: {
      id: '"Tetap konsisten dalam belajar setiap hari. Amal yang sedikit namun berkelanjutan adalah yang paling dicintai oleh Sang Pencipta."',
      ar: '"حافظ على الاستمرارية في تعلمك اليومي. إن أحب الأعمال إلى الله أدومها وإن قل."',
    },
  },
  evaluations: {
    title: { id: 'Evaluasi & Ujian', ar: 'التقييمات والامتحانات' },
    subtitle: {
      id: 'Kelola kuis materi dan ujian komprehensif Anda',
      ar: 'إدارة اختبارات المواد والامتحانات الشاملة الخاصة بك',
    },
    quiz: { id: 'Kuis Materi', ar: 'اختبار مادة' },
    exam: { id: 'Ujian Akhir', ar: 'الامتحان النهائي' },
    survey: { id: 'Survei Umpan Balik', ar: 'استطلاع رأي' },
    passingScore: { id: 'Nilai Kelulusan', ar: 'درجة النجاح' },
    timeLimit: { id: 'Batas Waktu', ar: 'الحد الزمني' },
    attempts: { id: 'Sisa Percobaan', ar: 'المحاولات المتبقية' },
    noEvaluations: { id: 'Belum ada evaluasi yang tersedia.', ar: 'لا توجد تقييمات متاحة بعد.' },
    startBtn: { id: 'Mulai Pengerjaan', ar: 'بدء المحاولة' },
    resultsBtn: { id: 'Lihat Hasil', ar: 'عرض النتائج' },
    infinite: { id: 'Tanpa Batas', ar: 'غير terbatas' }, // wait, 'غير محدود'
    minutes: { id: 'Menit', ar: 'دقائق' },
    loading: { id: 'Memuat penilaian...', ar: 'جاري تحميل التقييمات...' },
    errorTitle: { id: 'Gagal Memuat Penilaian', ar: 'خطأ في تحميل التقييمات' },
    noEvaluationsTitle: { id: 'Belum Ada Evaluasi', ar: 'لا توجد تقييمات بعد' },
    noEvaluationsDesc: {
      id: 'Anda belum memiliki evaluasi yang ditugaskan. Silakan cek kembali nanti atau selesaikan materi pembelajaran terlebih dahulu untuk membuka penilaian baru.',
      ar: 'لم يتم تعيين أي تقييمات لك بعد. يرجى التحقق لاحقًا أو إكمال المزيد من المواد لفتح تقييمات جديدة.',
    },
    totalAssigned: {
      id: 'total penilaian ditugaskan kepada Anda',
      ar: 'إجمالي التقييمات المعينة لك',
    },
    generalAssessments: { id: 'Penilaian Umum', ar: 'التقييمات العامة' },
    noDescription: { id: 'Tidak ada deskripsi', ar: 'لا يوجد وصف' },
    noLimit: { id: 'Tanpa Batas', ar: 'بدون حد' },
    passMark: { id: 'Nilai Kelulusan', ar: 'درجة النجاح' },
    statusPassed: { id: 'Lulus', ar: 'ناجح' },
    statusRemedial: { id: 'Perlu Remedial', ar: 'يحتاج إعادة' },
    statusNotAttempted: { id: 'Belum Dikerjakan', ar: 'لم يتم إنجازه' },
    filterAll: { id: 'Semua Evaluasi', ar: 'جميع التقييمات' },
    filterPending: { id: 'Belum Selesai / Tertunda', ar: 'معلق / غير مكتمل' },
    filterCompleted: { id: 'Sudah Selesai / Lulus', ar: 'مكتمل / ناجح' },
    allPrograms: { id: 'Semua Program', ar: 'جميع البرامج' },
    searchPlaceholder: { id: 'Cari judul evaluasi...', ar: 'البحث عن تقييم...' },
    takeExamBtn: { id: 'Kerjakan Sekarang', ar: 'بدء الآن' },
    retakeExamBtn: { id: 'Ulangi Ujian', ar: 'إعادة المحاولة' },
    viewResultBtn: { id: 'Lembar Hasil', ar: 'عرض النتيجة' },
    score: { id: 'Nilai', ar: 'الدرجة' },
    lockedExam: { id: 'Terkunci (Selesaikan materi sebelumnya)', ar: 'مغلق (أكمل الدروس السابقة)' },
  },
  evaluationDetail: {
    title: { id: 'Lembar Evaluasi', ar: 'ورقة التقييم' },
    backToCurriculum: { id: 'Kembali ke kurikulum program', ar: 'العودة إلى منهج البرنامج' },
    continueCurriculum: { id: 'Lanjut ke tahap berikutnya', ar: 'متابعة المرحلة التالية' },
    duration: { id: 'Batas Waktu', ar: 'الحد الزمني' },
    remainingTime: { id: 'Sisa Waktu', ar: 'الوقت المتبقي' },
    question: { id: 'Pertanyaan', ar: 'سؤال' },
    nextBtn: { id: 'Selanjutnya', ar: 'التالي' },
    prevBtn: { id: 'Sebelumnya', ar: 'السابق' },
    submitBtn: { id: 'Kirim Jawaban', ar: 'إرسال الإجابات' },
    confirmSubmit: {
      id: 'Apakah Anda yakin ingin mengirim jawaban ini?',
      ar: 'هل أنت متأكد من إرسال هذه الإجابة؟',
    },
    calibration: { id: 'Menghitung skor Anda...', ar: 'جاري حساب درجتك...' },
    submitting: { id: 'Mengirimkan jawaban...', ar: 'جاري إرسال الإجابة...' },
    loading: { id: 'Menyelaraskan data penilaian...', ar: 'جاري مزامنة بيانات التقييم...' },
    errorTitle: { id: 'Penilaian Offline', ar: 'التقييم غير متصل' },
    errorDesc: {
      id: 'Kami tidak dapat menyelaraskan data penilaian. Silakan coba lagi nanti.',
      ar: 'لم نتمكن من مزامنة بيانات التقييم. يرجى المحاولة مرة أخرى لاحقًا.',
    },
    backBtn: { id: 'Kembali ke Evaluasi', ar: 'العودة إلى التقييمات' },
    passedTitle: { id: 'Mabruk! Anda Lulus.', ar: 'مبروك! لقد نجحت.' },
    failedTitle: { id: 'Belum Lulus.', ar: 'لم تنجح بعد.' },
    passedDesc: {
      id: 'Dedikasi belajar Anda membuahkan hasil. Anda telah menguasai materi ini.',
      ar: 'لقد أثمر تفانيك في التعلم. لقد أتقنت هذه المادة.',
    },
    failedDesc: {
      id: 'Mengulang adalah bagian dari perjalanan belajar. Pelajari kembali materi dan coba lagi saat Anda siap.',
      ar: 'المراجعة جزء من رحلة التعلم. راجع المواد وحاول مرة أخرى عندما تكون مستعدًا.',
    },
    performance: { id: 'Performa Anda', ar: 'أداؤك' },
    passingScore: { id: 'Nilai Kelulusan', ar: 'درجة النجاح' },
    submitted: { id: 'Terkirim', ar: 'تم الإرسال' },
    timeUsed: { id: 'Waktu Digunakan', ar: 'الوقت المستغرق' },
    minutes: { id: 'menit', ar: 'دقائق' },
    proceedReflection: { id: 'Lanjut ke Refleksi', ar: 'الانتقال إلى التأمل' },
    continueLearning: { id: 'Lanjutkan Belajar', ar: 'مواصلة التعلم' },
    retakeBtn: { id: 'Kerjakan Ulang Evaluasi', ar: 'إعادة المحاولة' },
    finishBtn: { id: 'Selesai', ar: 'إنهاء' },
    recheckConfirmTitle: { id: 'Periksa Kembali Jawaban?', ar: 'هل تريد مراجعة الإجابات؟' },
    recheckConfirmDesc: {
      id: 'Apakah Anda ingin mengirimkan jawaban Anda sekarang, atau ingin memeriksanya kembali terlebih dahulu?',
      ar: 'هل تريد إرسال إجاباتك الآن، أم تريد مراجعتها أولاً؟',
    },
    recheckConfirmSubmit: { id: 'Kirim Jawaban', ar: 'إرسال الإجابات' },
    recheckConfirmCancel: { id: 'Periksa Kembali', ar: 'مراجعة' },
    unansweredWarning: {
      id: 'Ada {count} soal yang belum dijawab. Selesaikan semua soal terlebih dahulu.',
      ar: 'هناك {count} أسئلة لم تتم الإجابة عليها. يرجى إكمال جميع الأسئلة أولاً.',
    },
    allAnsweredFeedback: {
      id: 'Semua soal telah dijawab. Anda dapat mengirimkan jawaban sekarang.',
      ar: 'لقد تمت الإجابة على جميع الأسئلة. يمكنك إرسال الإجابات الآن.',
    },
    rules: { id: 'Aturan Penilaian', ar: 'قواعد التقييم' },
    timeLimit: { id: 'Batas Waktu', ar: 'الحد الزمني' },
    passingCriteria: { id: 'Kriteria Kelulusan', ar: 'معايير النجاح' },
    passingCriteriaDesc: {
      id: 'Dibutuhkan skor minimal {score}%',
      ar: 'مطلوب درجة لا تقل عن {score}%',
    },
    attemptLimit: { id: 'Batas Percobaan', ar: 'حد المحاولات' },
    attemptLimitDesc: {
      id: 'Maksimal {max} kali percobaan',
      ar: 'الحد الأقصى {max} محاولات مسموح بها',
    },
    questionPool: { id: 'Bank Soal', ar: 'بنك الأسئلة' },
    questionPoolDesc: {
      id: 'Sistem akan mengambil {sample} dari {total} soal di bank secara acak untuk setiap percobaan.',
      ar: 'سيقوم النظام بسحب {sample} من أصل {total} سؤال في البنك بشكل عشوائي لكل محاولة.',
    },
    attemptLimitReached: {
      id: 'Batas maksimal percobaan telah tercapai.',
      ar: 'تم الوصول إلى الحد الأقصى للمحاولات.',
    },
    attemptLimitReachedDesc: {
      id: 'Anda tidak dapat mengerjakan ulang evaluasi ini karena batas percobaan ({max}) telah habis. Silakan hubungi admin jika Anda membutuhkan bantuan.',
      ar: 'لا يمكنك إعادة محاولة هذا التقييم لأن حد المحاولات ({max}) قد نفد. يرجى الاتصال بالمسؤول إذا كنت بحاجة إلى مساعدة.',
    },
    ackStart: {
      id: 'Dengan mengeklik mulai, Anda menyatakan siap untuk memulai.',
      ar: 'بالنقر على بدء، فإنك تقر بأنك مستعد للبدء.',
    },
    ackExam: {
      id: 'Ini adalah ujian akhir dengan pengaruh signifikan terhadap sertifikasi Anda.',
      ar: 'هذا امتحان نهائي وله وزن كبير في شهادتك.',
    },
    startBtn: { id: 'Mulai Penilaian', ar: 'بدء التقييم' },
    lockedTitle: { id: 'Evaluasi Belum Terbuka', ar: 'التقييم غير متاح بعد' },
    lockedDesc: {
      id: 'Selesaikan seluruh materi pada bagian pembelajaran ini sebelum memulai evaluasi.',
      ar: 'أكمل جميع مواد هذا القسم التعليمي قبل بدء التقييم.',
    },
    lockedProgress: {
      id: 'Materi selesai: {completed} dari {required}',
      ar: 'المواد المكتملة: {completed} من {required}',
    },
    returnToMaterials: { id: 'Kembali dan Selesaikan Materi', ar: 'العودة وإكمال المواد' },
    retakeLocked: {
      id: 'Percobaan ulang akan terbuka setelah seluruh materi terkait selesai.',
      ar: 'ستتاح إعادة المحاولة بعد إكمال جميع المواد ذات الصلة.',
    },
    defaultDesc: {
      id: 'Selamat datang di penilaian ini. Harap pastikan Anda berada di lingkungan yang tenang dan telah mempelajari materi prasyarat.',
      ar: 'مرحباً بك في هذا التقييم. يرجى التأكد من أنك في بيئة هادئة ومراجعة المواد المطلوبة.',
    },
    correctAnswer: { id: 'Jawaban Benar', ar: 'الإجابة الصحيحة' },
    yourAnswer: { id: 'Jawaban Anda', ar: 'إجابتك' },
    reviewTitle: { id: 'Pembahasan Jawaban', ar: 'مراجعة الإجابات' },
    reviewLink: { id: 'Lihat jawaban per soal', ar: 'عرض إجابات كل سؤال' },
    retryLoad: { id: 'Muat ulang hasil evaluasi', ar: 'إعادة تحميل نتيجة التقييم' },
    reviewMissing: {
      id: 'Soal atau rekaman jawaban untuk percobaan ini tidak tersedia. Nilai Anda tetap tersimpan. Hubungi BID Support untuk pemeriksaan; jangan mengulang ujian hanya untuk membuka pembahasan.',
      ar: 'أسئلة أو إجابات هذه المحاولة غير متاحة. درجتك محفوظة. تواصل مع دعم BID للتحقق؛ لا تعِد الاختبار لمجرد فتح المراجعة.',
    },
    answerMissing: {
      id: 'Jawaban Anda tersimpan, tetapi pilihan jawaban aslinya tidak tersedia lagi.',
      ar: 'إجابتك محفوظة، لكن خيار الإجابة الأصلي لم يعد متاحًا.',
    },
    submitFailed: {
      id: 'Jawaban belum berhasil dikirim. Pilihan Anda tetap ada di halaman ini. Periksa koneksi, lalu tekan Selesai untuk mencoba kembali.',
      ar: 'لم يتم إرسال الإجابات بنجاح. لا تزال إجاباتك في هذه الصفحة. تحقق من الاتصال، ثم اضغط إنهاء للمحاولة مجددًا.',
    },
    reviewUnavailable: {
      id: 'Jawaban per soal untuk nilai lama ini tidak tersimpan. Nilai tetap dapat dilihat, tetapi jawaban benar dan salah tidak dapat dipulihkan.',
      ar: 'لم تُحفظ إجابات الأسئلة لهذه النتيجة القديمة. يمكنك رؤية الدرجة، لكن لا يمكن استعادة الإجابات الصحيحة والخاطئة.',
    },
    correctAnswersHidden: {
      id: 'Kunci jawaban belum tersedia saat percobaan lain masih aktif atau disembunyikan oleh pengajar. Jawaban Anda tetap dapat dilihat.',
      ar: 'مفتاح الإجابات غير متاح أثناء وجود محاولة أخرى نشطة أو إذا أخفاه المعلم. لا تزال إجاباتك ظاهرة.',
    },
    unanswered: { id: 'Belum dijawab', ar: 'لم تتم الإجابة' },
    isCorrect: { id: 'Benar', ar: 'صحيح' },
    isIncorrect: { id: 'Salah', ar: 'خطأ' },
    explanation: { id: 'Penjelasan', ar: 'شرح' },
  },
  results: {
    calculating: { id: 'Menghitung hasil belajar Anda...', ar: 'جاري حساب نتائجك الدراسية...' },
    errorTitle: { id: 'Gagal Memuat Hasil', ar: 'خطأ في تحميل النتائج' },
    noResultsTitle: { id: 'Belum Ada Hasil', ar: 'لا توجد نتائج بعد' },
    noResultsDesc: {
      id: 'Selesaikan program belajar untuk melihat laporan hasil belajar Anda di sini.',
      ar: 'أكمل البرامج الدراسية لعرض تقارير نتائجك هنا.',
    },
    title: { id: 'Hasil Belajar', ar: 'نتائج التعلم' },
    subtitle: {
      id: 'Status ketuntasan Anda di seluruh program belajar',
      ar: 'حالة إكمالك عبر جميع البرامج الدراسية',
    },
    score: { id: 'Nilai', ar: 'الدرجة' },
    passed: { id: 'Tuntas', ar: 'ناجح' },
    failed: { id: 'Belum Tuntas', ar: 'غير ناجح' },
    certTitle: { id: 'Sertifikat Kelulusan', ar: 'شهادة التخرج' },
    downloadCert: { id: 'Unduh Sertifikat', ar: 'تنزيل الشهادة' },
    feedbackTitle: { id: 'Umpan Balik Pengajar', ar: 'ملاحظات المعلم العلمي' },
    strengths: { id: 'Kelebihan Anda', ar: 'نقاط القوة' },
    weaknesses: { id: 'Perlu Penguatan', ar: 'بحاجة إلى تعزيز' },
    recommendations: { id: 'Rekomendasi Jalur', ar: 'المسار الموصى به' },
    noResults: { id: 'Tidak ada hasil penilaian untuk ditampilkan.', ar: 'لا توجد نتائج لعرضها.' },
    answerHistory: { id: 'Hasil Kuis & Ujian', ar: 'نتائج الاختبارات والامتحانات' },
    answerHistoryDesc: {
      id: 'Buka nilai terbaik yang tersimpan untuk meninjau jawaban pada setiap soal.',
      ar: 'افتح أفضل درجة محفوظة لمراجعة إجابات كل سؤال.',
    },
    reviewScore: { id: 'Lihat Hasil', ar: 'عرض النتيجة' },
    answersUnavailable: {
      id: 'Jawaban per soal tidak tersedia untuk hasil lama ini.',
      ar: 'إجابات الأسئلة غير متاحة لهذه النتيجة القديمة.',
    },
    comprehensive: { id: 'Ujian Komprehensif (Wajib)', ar: 'الامتحان الشامل (مطلوب)' },
    reflectionLabel: { id: 'Refleksi Pembelajaran (Wajib)', ar: 'التأمل التعليمي (مطلوب)' },
    overallSummary: { id: 'Ringkasan Keseluruhan', ar: 'الملخص العام' },
    totalPrograms: { id: 'Total Program', ar: 'إجمالي البرامج' },
    completed: { id: 'Selesai', ar: 'مكتمل' },
    inProgress: { id: 'Sedang Berjalan', ar: 'قيد التنفيذ' },
    avgProgress: { id: 'Rata-rata Kemajuan', ar: 'متوسط التقدم' },
    evaluationLocked: { id: 'Terkunci', ar: 'مغلق' },
    completeMaterialsFirst: {
      id: 'Selesaikan seluruh materi terkait terlebih dahulu.',
      ar: 'أكمل جميع المواد ذات الصلة أولاً.',
    },
    completeRemainingMaterials: {
      id: 'Selesaikan {count} materi lagi untuk membuka evaluasi.',
      ar: 'أكمل {count} مواد أخرى لفتح التقييم.',
    },
  },
  profile: {
    editDescription: {
      id: 'Perbarui data pribadi Anda. Email dikelola terpisah melalui verifikasi.',
      ar: 'حدّث بياناتك الشخصية. يُدار البريد الإلكتروني بشكل منفصل عبر التحقق.',
    },
    identitySection: { id: 'Identitas dan kontak', ar: 'الهوية وبيانات الاتصال' },
    backgroundSection: { id: 'Latar belakang', ar: 'الخلفية' },
    avatarHelp: {
      id: 'JPEG, PNG, WebP, atau GIF. Maksimal 5 MB.',
      ar: 'JPEG أو PNG أو WebP أو GIF. الحد الأقصى 5 ميغابايت.',
    },
    avatarInvalid: {
      id: 'Pilih foto JPEG, PNG, WebP, atau GIF dengan ukuran maksimal 5 MB.',
      ar: 'اختر صورة JPEG أو PNG أو WebP أو GIF بحجم لا يتجاوز 5 ميغابايت.',
    },
    removeAvatar: { id: 'Hapus foto', ar: 'حذف الصورة' },
    nameHelp: {
      id: 'Gunakan 2–100 karakter untuk nama lengkap.',
      ar: 'استخدم من حرفين إلى 100 حرف للاسم الكامل.',
    },
    nameInvalid: {
      id: 'Nama harus terdiri dari 2–100 karakter.',
      ar: 'يجب أن يتكون الاسم من حرفين إلى 100 حرف.',
    },
    phoneHelp: {
      id: 'Gunakan nomor Indonesia (08…) atau awalan internasional (+…).',
      ar: 'استخدم رقماً إندونيسياً (08…) أو بادئة دولية (+…).',
    },
    phoneRequired: {
      id: 'Nomor yang sudah digunakan untuk masuk tidak dapat dikosongkan.',
      ar: 'لا يمكن حذف رقم الهاتف المستخدم لتسجيل الدخول.',
    },
    phoneInvalid: { id: 'Masukkan nomor telepon yang valid.', ar: 'أدخل رقم هاتف صالحاً.' },
    domisili: { id: 'Kota / kabupaten domisili', ar: 'مدينة / منطقة الإقامة' },
    domisiliHelp: {
      id: 'Maksimal 200 karakter. Data domisili pada pendaftaran juga diperbarui.',
      ar: 'الحد الأقصى 200 حرف. تُحدّث أيضاً بيانات الإقامة في التسجيلات.',
    },
    domisiliInvalid: { id: 'Domisili maksimal 200 karakter.', ar: 'الإقامة بحد أقصى 200 حرف.' },
    dateInvalid: {
      id: 'Tanggal lahir harus valid dan tidak di masa depan.',
      ar: 'يجب أن يكون تاريخ الميلاد صالحاً وليس في المستقبل.',
    },
    backgroundInvalid: {
      id: 'Keterangan lainnya harus terdiri dari 2–100 karakter.',
      ar: 'يجب أن يتكون وصف «أخرى» من حرفين إلى 100 حرف.',
    },
    backgroundKeep: {
      id: 'Data yang sudah tersimpan tidak dapat dikosongkan di sini. Pilih nilai lain untuk menggantinya.',
      ar: 'لا يمكن حذف البيانات المحفوظة هنا. اختر قيمة أخرى لاستبدالها.',
    },
    discardTitle: { id: 'Buang perubahan?', ar: 'تجاهل التغييرات؟' },
    discardDescription: {
      id: 'Perubahan belum disimpan. Kembali untuk melanjutkan, atau buang perubahan.',
      ar: 'لم تُحفظ التغييرات. عُد للمتابعة أو تجاهل التغييرات.',
    },
    keepEditing: { id: 'Lanjutkan mengedit', ar: 'متابعة التعديل' },
    discard: { id: 'Buang perubahan', ar: 'تجاهل التغييرات' },
    refreshError: {
      id: 'Data terbaru belum dapat dimuat. Data tersimpan tetap ditampilkan; coba lagi saat koneksi pulih.',
      ar: 'تعذر تحميل أحدث البيانات. تُعرض البيانات المحفوظة؛ حاول مجدداً عند استعادة الاتصال.',
    },
    changeEmail: { id: 'Ubah email', ar: 'تغيير البريد الإلكتروني' },
    changeEmailDescription: {
      id: 'Email lama tetap berlaku sampai alamat baru diverifikasi. Tautan berlaku selama 20 menit.',
      ar: 'يبقى البريد القديم سارياً حتى التحقق من العنوان الجديد. الرابط صالح لمدة 20 دقيقة.',
    },
    newEmail: { id: 'Email baru', ar: 'البريد الإلكتروني الجديد' },
    emailInvalid: {
      id: 'Masukkan email baru yang valid dan berbeda dari email saat ini.',
      ar: 'أدخل بريداً جديداً صالحاً ومختلفاً عن البريد الحالي.',
    },
    passwordRequired: {
      id: 'Masukkan password saat ini untuk melanjutkan.',
      ar: 'أدخل كلمة المرور الحالية للمتابعة.',
    },
    emailRequest: { id: 'Kirim tautan verifikasi', ar: 'إرسال رابط التحقق' },
    emailResend: { id: 'Kirim ulang tautan', ar: 'إعادة إرسال الرابط' },
    emailCooldown: {
      id: 'Kirim ulang tersedia dalam {seconds} detik.',
      ar: 'يمكن إعادة الإرسال بعد {seconds} ثانية.',
    },
    emailRequested: {
      id: 'Permintaan diterima. Jika alamat tersedia, tautan dikirim ke email baru. Periksa kotak masuk dan spam. Masukkan password lagi untuk mengirim ulang.',
      ar: 'تم قبول الطلب. إذا كان العنوان متاحاً، يُرسل الرابط إلى البريد الجديد. تحقق من الوارد والبريد غير المرغوب. أدخل كلمة المرور مجدداً لإعادة الإرسال.',
    },
    emailRequestError: {
      id: 'Permintaan tidak berhasil. Periksa password saat ini dan coba lagi nanti.',
      ar: 'لم ينجح الطلب. تحقق من كلمة المرور الحالية وحاول لاحقاً.',
    },
    emailConfirmTitle: { id: 'Konfirmasi perubahan email', ar: 'تأكيد تغيير البريد الإلكتروني' },
    emailConfirmDescription: {
      id: 'Tautan sudah dibuka. Email hanya berubah jika Anda memilih Konfirmasi. Jika tautan kedaluwarsa, minta tautan baru melalui Ubah email.',
      ar: 'تم فتح الرابط. لن يتغير البريد إلا إذا اخترت التأكيد. إذا انتهت صلاحية الرابط، اطلب رابطاً جديداً عبر تغيير البريد.',
    },
    emailConfirm: { id: 'Konfirmasi perubahan', ar: 'تأكيد التغيير' },
    emailConfirmError: {
      id: 'Tautan tidak dapat digunakan. Tautan mungkin kedaluwarsa, sudah digunakan, atau milik akun lain. Minta tautan baru melalui Ubah email.',
      ar: 'لا يمكن استخدام الرابط. قد يكون منتهياً أو مستخدماً أو يخص حساباً آخر. اطلب رابطاً جديداً عبر تغيير البريد.',
    },
    emailChanged: {
      id: 'Email berhasil diubah: {oldEmail} → {newEmail}. Sesi di perangkat lain perlu masuk kembali.',
      ar: 'تم تغيير البريد: {oldEmail} ← {newEmail}. يجب تسجيل الدخول مجدداً على الأجهزة الأخرى.',
    },
    title: { id: 'Profil Peserta', ar: 'ملف المشارك' },
    accountOverview: { id: 'Ruang Akun Peserta', ar: 'مساحة حساب المشارك' },
    backToDashboard: { id: 'Kembali ke dashboard', ar: 'العودة إلى لوحة التحكم' },
    accountReady: { id: 'Akun peserta aktif', ar: 'حساب المشارك نشط' },
    profileCompletion: { id: 'Kelengkapan profil', ar: 'اكتمال الملف الشخصي' },
    profileCompletionDesc: {
      id: 'Lengkapi data agar layanan akademik dan komunikasi tetap lancar.',
      ar: 'أكمل بياناتك لضمان سلاسة الخدمات الأكاديمية والتواصل.',
    },
    profileNavigation: { id: 'Navigasi profil', ar: 'التنقل في الملف الشخصي' },
    profileIdentity: { id: 'Identitas', ar: 'الهوية' },
    profileLearning: { id: 'Pembelajaran', ar: 'التعلم' },
    profileAccount: { id: 'Akun & Keamanan', ar: 'الحساب والأمان' },
    subtitle: {
      id: 'Kelola informasi pribadi dan data akademik Anda',
      ar: 'إدارة معلوماتك الشخصية وبياناتك الأكاديمية',
    },
    personalInfo: { id: 'Informasi Pribadi', ar: 'المعلومات الشخصية' },
    participantNip: { id: 'Nomor Induk Peserta (NIP)', ar: 'الرقم الأكاديمي للمشارك' },
    participantNipShort: { id: 'NIP', ar: 'الرقم الأكاديمي' },
    academicInfo: { id: 'Status Akademik', ar: 'الحالة الأكاديمية' },
    updateBtn: { id: 'Perbarui Profil', ar: 'تحديث الملف الشخصي' },
    successMsg: { id: 'Profil berhasil diperbarui.', ar: 'تم تحديث الملف الشخصي بنجاح.' },
    errorMsg: { id: 'Gagal memperbarui profil.', ar: 'فشل تحديث الملف الشخصي.' },
    name: { id: 'Nama Lengkap', ar: 'الاسم الكامل' },
    email: { id: 'Alamat Email', ar: 'البريد الإلكتروني' },
    phone: { id: 'Nomor Telepon (WhatsApp)', ar: 'رقم الهاتف (الواتساب)' },
    gender: { id: 'Jenis Kelamin', ar: 'الجنس' },
    editProfile: { id: 'Edit Profil', ar: 'تعديل الملف الشخصي' },
    tagline: {
      id: 'Mempelajari ilmu-ilmu Islam dan pengetahuan tradisional',
      ar: 'تعلم العلوم الإسلامية والمعارف التقليدية',
    },
    memberSince: { id: 'Anggota sejak', ar: 'عضو منذ' },
    recently: { id: 'Baru-baru ini', ar: 'مؤخراً' },
    contactInfo: { id: 'Informasi Kontak', ar: 'معلومات الاتصال' },
    manageDetails: { id: 'Kelola data', ar: 'إدارة البيانات' },
    change: { id: 'Ubah', ar: 'تغيير' },
    myRegistrations: { id: 'Pendaftaran & Bukti Saya', ar: 'تسجيلاتي وإيصالاتي' },
    registrationRecords: { id: 'Riwayat pendaftaran', ar: 'سجل التسجيلات' },
    viewPrograms: { id: 'Lihat program', ar: 'عرض البرامج' },
    openProgram: { id: 'Buka program', ar: 'فتح البرنامج' },
    browsePrograms: { id: 'Jelajahi program', ar: 'استكشف البرامج' },
    receipt: { id: 'Bukti', ar: 'إيصال' },
    noRegistrations: {
      id: 'Tidak ada pendaftaran ditemukan.',
      ar: 'لم يتم العثور على أي تسجيلات.',
    },
    learningStats: { id: 'Statistik Belajar', ar: 'إحصائيات التعلم' },
    learningOverview: { id: 'Ringkasan perjalanan belajar', ar: 'ملخص مسيرة التعلم' },
    activePrograms: { id: 'Program Aktif', ar: 'البرامج النشطة' },
    materialsCompleted: { id: 'Materi Selesai', ar: 'المواد المكتملة' },
    programsCompleted: { id: 'Program Selesai', ar: 'البرامج المكتملة' },
    avgCompletion: { id: 'Rata-rata Ketuntasan', ar: 'متوسط الإكمال' },
    accountSettings: { id: 'Pengaturan Akun', ar: 'إعدادات الحساب' },
    accountAndSecurity: { id: 'Akun dan keamanan', ar: 'الحساب والأمان' },
    dataProfile: { id: 'Data profil', ar: 'بيانات الملف الشخصي' },
    dataProfileDesc: {
      id: 'Perbarui identitas, kontak, dan foto profil.',
      ar: 'حدّث الهوية وبيانات الاتصال والصورة الشخصية.',
    },
    securityDesc: {
      id: 'Perbarui kata sandi untuk menjaga akses akun.',
      ar: 'حدّث كلمة المرور للحفاظ على أمان الوصول للحساب.',
    },
    changePassword: { id: 'Ubah Kata Sandi', ar: 'تغيير كلمة المرور' },
    notificationPrefs: { id: 'Preferensi Notifikasi', ar: 'تفضيلات الإشعارات' },
    privacySettings: { id: 'Pengaturan Privasi', ar: 'إعدادات الخصوصية' },
    signOut: { id: 'Keluar', ar: 'تسجيل الخروج' },
    signOutDesc: {
      id: 'Akhiri sesi pada perangkat ini.',
      ar: 'إنهاء الجلسة على هذا الجهاز.',
    },
    dangerZone: { id: 'Zona Bahaya', ar: 'منطقة الخطر' },
    cannotBeUndone: {
      id: 'Tindakan ini tidak dapat dibatalkan.',
      ar: 'لا يمكن التراجع عن هذا الإجراء.',
    },
    deleteAccount: { id: 'Hapus Akun', ar: 'حذف الحساب' },
    confirmSignOut: { id: 'Apakah Anda yakin ingin keluar?', ar: 'هل أنت متأكد من تسجيل الخروج؟' },
    currentPasswordLabel: { id: 'Password Saat Ini', ar: 'كلمة المرور الحالية' },
    newPasswordLabel: { id: 'Password Baru', ar: 'كلمة المرور الجديدة' },
    confirmNewPasswordLabel: { id: 'Konfirmasi Password Baru', ar: 'تأكيد كلمة المرور الجديدة' },
    showPassword: { id: 'Tampilkan kata sandi', ar: 'إظهار كلمة المرور' },
    hidePassword: { id: 'Sembunyikan kata sandi', ar: 'إخفاء كلمة المرور' },
    saving: { id: 'Menyimpan...', ar: 'جاري الحفظ...' },
    errorChangePassword: { id: 'Gagal mengubah password', ar: 'فشل تغيير كلمة المرور' },
    passwordMismatch: {
      id: 'Konfirmasi password baru tidak cocok',
      ar: 'تأكيد كلمة المرور الجديدة غير متطابق',
    },
    passwordMinLength: {
      id: 'Password baru minimal 8 karakter',
      ar: 'كلمة المرور الجديدة يجب أن تكون 8 أحرف على الأقل',
    },
    avatar: { id: 'Avatar', ar: 'الصورة الشخصية' },
    uploadImage: { id: 'Unggah Foto', ar: 'تحميل الصورة' },
    nameShort: { id: 'Nama', ar: 'الاسم' },
    genderMale: { id: 'Laki-laki (Ikhwan)', ar: 'ذكر (إخوان)' },
    genderFemale: { id: 'Perempuan (Akhwat)', ar: 'أنثى (أخوات)' },
    dateOfBirth: { id: 'Tanggal Lahir', ar: 'تاريخ الميلاد' },
    age: { id: 'Usia', ar: 'العمر' },
    ageSummary: { id: '{age} tahun', ar: '{age} سنة' },
  },
  receipt: {
    title: { id: 'Bukti Pendaftaran', ar: 'إثبات التسجيل' },
    subtitle: {
      id: 'Tanda bukti pendaftaran program belajar resmi Anda',
      ar: 'إيصال رسمي لتسجيلك في البرنامج الدراسي',
    },
    invoiceNo: { id: 'Nomor Bukti', ar: 'رقم الإيصال' },
    paymentDate: { id: 'Tanggal Terbit', ar: 'تاريخ الإصدار' },
    amount: { id: 'Nominal', ar: 'المبلغ' },
    status: { id: 'Status Validasi', ar: 'حالة التحقق' },
    downloadPdf: { id: 'Unduh Bukti (PDF)', ar: 'تنزيل الإيصال (PDF)' },
    closeBtn: { id: 'Tutup Halaman', ar: 'إغلاق الصفحة' },
    backToDashboard: { id: 'Kembali ke Dashboard', ar: 'العودة إلى لوحة القيادة' },
    printArchive: { id: 'Cetak Bukti', ar: 'طباعة الإيصال' },
    dossierProof: { id: 'Bukti Dokumen', ar: 'إثبات المستند' },
    digitalReceiptSub: {
      id: 'Bukti Pendaftaran Digital • LMS BID V3',
      ar: 'إيصال التسجيل الرقمي • LMS BID V3',
    },
    identifier: { id: 'Identifikasi', ar: 'المعرف' },
    scholarIdentity: { id: 'Identitas Peserta', ar: 'هوية المشارك' },
    scholarIdentifier: { id: 'Nomor Induk Peserta', ar: 'رقم تعريف المشارك' },
    communication: { id: 'Komunikasi', ar: 'الاتصال' },
    academicTrack: { id: 'Jalur Akademik', ar: 'المسار الأكاديمي' },
    calibrationDate: { id: 'Tanggal Kalibrasi', ar: 'تاريخ المعايرة' },
    currentStatus: { id: 'Status Saat Ini', ar: 'الحالة الحالية' },
    adminSupport: { id: 'Dukungan Administrasi', ar: 'الدعم الإداري' },
    pendingAuthorization: { id: 'Menunggu Otorisasi', ar: 'في انتظار التفويض' },
    pendingSync: { id: 'Menunggu Sinkronisasi', ar: 'في انتظار المزامنة' },
    certProof: {
      id: 'Bukti dokumen bersertifikat elektronik.',
      ar: 'إثبات مستند معتمد إلكترونياً.',
    },
    secureTrans: {
      id: 'Protokol belajar warisan v4.2 • Transmisi Aman aktif.',
      ar: 'بروتوكول تعلم التراث v4.2 • البث الآمن نشط.',
    },
    notFound: {
      id: 'Bukti tidak ditemukan atau Anda tidak memiliki akses.',
      ar: 'الإيصال غير موجود أو لا تملك صلاحية الوصول إليه.',
    },
  },
  reflectionDetail: {
    title: { id: 'Refleksi Pembelajaran', ar: 'التأمل والتلخيص' },
    subtitle: {
      id: 'Tulis telaah kritis dan pemahaman Anda terhadap program',
      ar: 'اكتب مراجعتك وفهمك للبرنامج',
    },
    submitBtn: { id: 'Kirim Refleksi Resmi', ar: 'إرسال التأمل الرسمي' },
    draftBtn: { id: 'Simpan Draf', ar: 'حفظ كمسودة' },
    revisionNeeded: { id: 'Butuh Revisi', ar: 'بحاجة إلى مراجعة' },
    approved: { id: 'Disetujui', ar: 'مقبول' },
    redirecting: {
      id: 'Mengarahkan ke Hasil Akhir...',
      ar: 'جاري التوجيه إلى النتائج النهائية...',
    },
    submittedTitle: { id: 'Refleksi Dikirim!', ar: 'تم إرسال التأمل!' },
    submittedDesc: {
      id: 'Jazakumullahu khairan telah berbagi perjalanan Anda. Refleksi Anda telah dikirim ke mentor untuk ditinjau.',
      ar: 'جزاكم الله خيراً على مشاركة مسيرتكم. تم إرسال تأملكم إلى الموجهين للمراجعة.',
    },
    backToCurriculum: { id: 'Kembali ke Kurikulum', ar: 'العودة إلى المنهج الدراسي' },
    finalMilestone: { id: 'Pencapaian Akhir', ar: 'المرحلة النهائية' },
    reflectionIntro: {
      id: 'Alhamdulillah, Anda telah menyelesaikan seluruh materi dan evaluasi di program {name}. Sebagai langkah akhir, silakan bagikan refleksi Anda.',
      ar: 'الحمد لله، لقد أكملت جميع المواد والتقييمات في برنامج {name}. كخطوة أخيرة، يرجى مشاركة تأملك.',
    },
    reflectionPrompt: {
      id: 'Refleksi Akhir Program: Apa yang Anda dapatkan dari program ini dan bagaimana rencana Anda mengamalkannya?',
      ar: 'التأمل النهائي للبرنامج: ما الذي استفدته من هذا البرنامج وكيف تخطط لتطبيقه؟',
    },
    mainPointLabel: {
      id: 'Apa poin utama yang paling berkesan bagi Anda?',
      ar: 'ما هي النقاط الرئيسية الأكثر تأثيراً بالنسبة لك؟',
    },
    mainPointHint: {
      id: 'Tuliskan minimal 2-3 paragraf mengenai pemahaman baru atau perubahan niat yang Anda rasakan.',
      ar: 'اكتب ما لا يقل عن 2-3 فقرات حول الفهم الجديد أو التغيير في النية الذي تشعر به.',
    },
    placeholder: { id: 'Tuliskan refleksi Anda di sini...', ar: 'اكتب تأملك هنا...' },
    submitAndFinish: {
      id: 'Kirim Refleksi & Selesaikan Program',
      ar: 'إرسال التأمل وإنهاء البرنامج',
    }, // wait, 'إرسال'
    completionStatus: { id: 'Status Ketuntasan', ar: 'حالة الإكمال' },
    curriculum: { id: 'Kurikulum', ar: 'المنهج الدراسي' },
    finalExam: { id: 'Ujian Akhir', ar: 'الامتحان النهائي' },
    nextStep: { id: 'Langkah Berikutnya', ar: 'الخطوة التالية' },
    reflection: { id: 'Refleksi', ar: 'التأمل' },
    mentorNote: { id: 'Catatan Mentor', ar: 'ملاحظة الموجه' },
    mentorNoteText: {
      id: '"Refleksi adalah bagian dari menjaga keberkahan ilmu. Tuliskan apa yang benar-benar Anda rasakan dan ingin Anda amalkan."',
      ar: '"التأمل جزء من الحفاظ على بركة العلم. اكتب ما تشعر به وتود تطبيقه فعلياً."',
    },
    passed: { id: 'Lulus', ar: 'ناجح' },
    failed: { id: 'Belum Lulus', ar: 'غير ناجح' },
  },
  mediaPlayer: {
    videoLabel: { id: 'Tonton video', ar: 'مشاهدة الفيديو' },
    audioLabel: { id: 'Dengarkan audio', ar: 'الاستماع إلى الصوت' },
    pdfLabel: { id: 'Baca PDF', ar: 'قراءة ملف PDF' },
    mediaChoices: { id: 'Pilih format materi', ar: 'اختر نوع المادة' },
    audioResource: { id: 'Dengarkan materi', ar: 'استمع إلى المادة' },
    audioResourceDesc: {
      id: 'Gunakan kontrol pemutar untuk mendengarkan sesuai kecepatan dan waktu Anda.',
      ar: 'استخدم أدوات المشغل للاستماع بالسرعة والوقت المناسبين لك.',
    },
    audioLoadFailed: {
      id: 'Audio gagal dimuat. Coba buka sumber di tab baru.',
      ar: 'تعذّر تحميل الصوت. افتح المصدر في علامة تبويب جديدة.',
    },
    noMedia: { id: 'Media Tidak Tersedia', ar: 'الوسائط غير متوفرة' },
    noMediaDesc: {
      id: 'Tidak ada konten media yang ditautkan ke materi ini. Silakan hubungi dukungan.',
      ar: 'لا يوجد محتوى وسائط مرتبط بهذه المادة حالياً. يرجى التواصل مع الدعم.',
    },
    loadFailed: { id: 'Gagal memuat video', ar: 'فشل تحميل الفيديو' },
    retryVideo: { id: 'Coba sumber video lagi', ar: 'إعادة المحاولة لتشغيل الفيديو' },
    nextVideoSource: { id: 'Coba sumber lainnya', ar: 'جرّب مصدراً آخر' },
    loadFailedDesc: {
      id: 'Sumber media mungkin tidak tersedia atau memerlukan otentikasi.',
      ar: 'قد يكون مصدر الوسائط غير متاح أو يتطلب مصادقة.',
    },
    browserNotSupportVideo: {
      id: 'Browser Anda tidak mendukung tag video.',
      ar: 'متصفحك لا يدعم تشغيل الفيديو.',
    },
    docResource: { id: 'Sumber Dokumen', ar: 'مصدر المستند' },
    docResourceDesc: {
      id: 'Silakan baca materi di bawah ini atau unduh salinannya.',
      ar: 'يرجى قراءة المادة أدناه أو تنزيل نسخة منها.',
    },
    openNewTab: { id: 'Buka di Tab Baru', ar: 'فتح في علامة تبويب جديدة' },
    download: { id: 'Unduh', ar: 'تنزيل' },
    previewNotAvailable: { id: 'Pratinjau tidak tersedia', ar: 'المعاينة غير متوفرة' },
    previewNotAvailableDesc: {
      id: 'Dokumen ini tidak dapat dipratinjau langsung di browser. Silakan unduh atau buka di tab baru.',
      ar: 'لا يمكن معاينة هذا المستند مباشرة في المتصفح. يرجى تنزيله أو فتحه في علامة تبويب جديدة.',
    },
    audioDisc: { id: 'Diskusi Audio', ar: 'النقاش الصوتي' },
    audioDiscDesc: {
      id: 'Dengarkan penjelasan ilmiah untuk materi ini.',
      ar: 'استمع إلى الشرح العلمي لهذه المادة.',
    },
    browserNotSupportAudio: {
      id: 'Browser Anda tidak mendukung elemen audio.',
      ar: 'متصفحك لا يدعم تشغيل الصوت.',
    },
    audioStreamUnavailable: { id: 'Aliran audio tidak tersedia', ar: 'البث الصوتي غير متوفر' },
    interactiveMaterial: { id: 'Materi Interaktif', ar: 'مادة تفاعلية' },
    interactiveMaterialDesc: {
      id: 'Materi ini dirancang untuk interaktif. Silakan gulir ke bawah untuk menyelesaikan tugas terkait.',
      ar: 'تم تصميم هذه المادة لتكون تفاعلية. يرجى التمرير لأسفل لإكمال المهام المرتبطة.',
    },
  },

  transcripts: {
    title: { id: 'Transkrip & Rapor Akademik', ar: 'كشف الدرجات والتقرير الأكاديمي' },
    subtitle: {
      id: 'Kartu hasil studi resmi, rekapitulasi nilai per mata pelajaran, dan yudisium kelulusan.',
      ar: 'بطاقة النتائج الدراسية الرسمية، وسجل الدرجات لكل مادة، والتقدير العام للتخرج.',
    },
    loading: { id: 'Memuat transkrip...', ar: 'جاري تحميل كشف الدرجات...' },
    emptyTitle: { id: 'Belum Ada Transkrip', ar: 'لا يوجد كشف درجات' },
    emptyDesc: {
      id: 'Transkrip akan tersedia setelah Anda menyelesaikan materi dan evaluasi dalam program.',
      ar: 'سيتوفر كشف الدرجات بعد إكمال المواد والتقييمات في البرنامج.',
    },
    browsePrograms: { id: 'Jelajahi Program', ar: 'تصفح البرامج' },
    semester: { id: 'Semester / Level', ar: 'الفصل / المستوى' },
    predicate: { id: 'Predikat', ar: 'التقدير' },
    totalGrades: { id: 'Nilai Total', ar: 'مجموع الدرجات' },
    percentage: { id: 'Persentase', ar: 'النسبة المئوية' },
    status: { id: 'Status', ar: 'الحالة' },
    completed: { id: 'Selesai / Lulus', ar: 'مكتمل / ناجح' },
    inProgress: { id: 'Sedang Berjalan', ar: 'قيد التنفيذ' },
    officialTranscriptTitle: {
      id: 'TRANSKRIP HASIL BELAJAR AKADEMIK',
      ar: 'كشف درجات التحصيل الأكاديمي الرسمي',
    },
    reportCardTitle: { id: 'Rapor Hasil Belajar', ar: 'تقرير نتائج التعلم' },
    officialSealNotice: {
      id: 'Dokumen ini sah dan diterbitkan resmi oleh Tarbiyah Sunnah Learning.',
      ar: 'هذه الوثيقة رسمية ومعتمدة صادرة عن تربية السنة للتعليم عن بعد.',
    },
    studentId: { id: 'Nomor Induk Peserta (NIP)', ar: 'الرقم الأكاديمي' },
    studentName: { id: 'Nama Peserta', ar: 'اسم الدارس' },
    programName: { id: 'Program Belajar', ar: 'البرنامج الدراسي' },
    completionDate: { id: 'Tanggal Kelulusan', ar: 'تاريخ التخرج' },
    gradeAverage: { id: 'Nilai Rata-rata Kumulatif (IPK)', ar: 'المعدل التراكمي العام' },
    graduationStatus: { id: 'Status Kelulusan', ar: 'حالة التخرج' },
    yudisium: { id: 'Yudisium & Predikat', ar: 'التقدير العام' },
    subjectCode: { id: 'Kode', ar: 'الرمز' },
    subjectName: { id: 'Mata Pelajaran', ar: 'المادة الدراسية' },
    sessionsCount: { id: 'Pertemuan', ar: 'اللقاءات' },
    finalScore: { id: 'Nilai Akhir', ar: 'الدرجة النهائية' },
    gradeLetter: { id: 'Huruf', ar: 'الرمز' },
    academicPredicate: { id: 'Predikat', ar: 'التقدير' },
    subjectStatus: { id: 'Status', ar: 'الحالة' },
    passed: { id: 'LULUS', ar: 'ناجح' },
    notPassed: { id: 'BELUM LULUS', ar: 'راسب' },
    inProgressStatus: { id: 'BERJALAN', ar: 'قيد الدراسة' },
    printTranscript: { id: 'Cetak Rapor / PDF', ar: 'طباعة الكشف / PDF' },
    verifyTranscript: { id: 'Verifikasi Keaslian', ar: 'التحقق من صحة الوثيقة' },
    verificationCode: { id: 'Kode Verifikasi', ar: 'رمز التحقق' },
    copiedCode: { id: 'Kode verifikasi disalin!', ar: 'تم نسخ رمز التحقق!' },
    backToResults: { id: 'Kembali ke Hasil Belajar', ar: 'العودة إلى النتائج' },
    viewCertificate: { id: 'Lihat Syahadah Kelulusan', ar: 'عرض شهادة التخرج' },
    directorSignature: {
      id: 'Pimpinan / Bagian Akademik TSL',
      ar: 'إدارة التعليم / الشؤون الأكاديمية',
    },
    viewOfficialTranscript: { id: 'Buka Transkrip Lengkap', ar: 'عرض الكشف الأكاديمي الكامل' },
    allPrograms: { id: 'Semua Program', ar: 'جميع البرامج' },

    // Legacy Transcripts Keys
    tabLmsTranscripts: { id: 'Transkrip Kurikulum Aktif (v3)', ar: 'كشف درجات المنهج الحالي (v3)' },
    tabLegacyTranscripts: {
      id: 'Histori Transkrip Program Masa Lalu',
      ar: 'أرشيف كشف الدرجات للبرامج السابقة',
    },
    currentTranscriptNavigation: { id: 'Buka Transkrip v3', ar: 'فتح كشف درجات v3' },
    legacyTranscriptNavigation: { id: 'Buka Riwayat Nilai', ar: 'فتح أرشيف الدرجات' },
    currentTranscriptContext: {
      id: 'Kurikulum aktif 6-tier',
      ar: 'المنهج الحالي بستة مستويات',
    },
    legacyArchiveContext: { id: 'Arsip sistem sebelumnya', ar: 'أرشيف النظام السابق' },
    legacyArchiveMap: { id: 'Peta riwayat belajar', ar: 'خريطة السجل الدراسي' },
    legacyArchiveMapHelp: {
      id: 'Pilih program untuk menyaring arsip. Data ini hanya untuk dibaca dan tidak mengubah capaian pada kurikulum v3.',
      ar: 'اختر البرنامج لتصفية الأرشيف. هذه البيانات للقراءة فقط ولا تغيّر إنجازات المنهج الحالي.',
    },
    clearLegacyFilters: { id: 'Reset filter', ar: 'إعادة تعيين التصفية' },
    legacyFilterResults: { id: 'Data nilai ditemukan', ar: 'سجلات الدرجات المعروضة' },
    legacyTitle: {
      id: 'Histori Transkrip Program Masa Lalu',
      ar: 'أرشيف كشف الدرجات والنتائج السابقة',
    },
    legacySubtitle: {
      id: 'Arsip riwayat capaian nilai akademik dari database sistem sebelumnya.',
      ar: 'أرشيف سجل الدرجات الأكاديمية والمعدل التراكمي من النظام السابق.',
    },
    legacyHierarchyNotice: {
      id: 'Arsip histori pembelajaran sistem lama: Nama Program > Semester > Mata Pelajaran > Nilai > Kumulatif.',
      ar: 'أرشيف سجل التعلم السابق: اسم البرنامج > الفصل > المادة الدراسية > الدرجة > المعدل التراكمي.',
    },
    activeHierarchyNotice: {
      id: 'Transkrip penilaian resmi program berjalan di LMS v3 berbasis capaian 6 Tahapan Pembelajaran.',
      ar: 'كشف التقييم الرسمي للبرنامج الحالي في LMS v3 القائم على إنجاز المراحل التعليمية الست.',
    },
    cumulativeGpa: { id: 'IPK Kumulatif Masa Lalu', ar: 'المعدل التراكمي السابق' },
    totalSemestersCompleted: { id: 'Semester Diselesaikan', ar: 'الفصول المكتملة' },
    totalCreditsLoad: { id: 'Total SKS / Beban Nilai', ar: 'إجمالي الساعات المعتمدة' },
    totalSubjectsPassed: { id: 'Mata Kuliah Lulus', ar: 'المواد المجتازة' },
    filterAllSemesters: { id: 'Semua Semester', ar: 'جميع الفصول' },
    filterSemesterPrefix: { id: 'Semester', ar: 'الفصل' },
    filterAllPrograms: {
      id: 'Semua Program / Angkatan Masa Lalu',
      ar: 'جميع البرامج / الدفعات السابقة',
    },
    searchSubjectPlaceholder: {
      id: 'Cari nama mata pelajaran atau kode...',
      ar: 'البحث عن اسم المادة أو الرمز...',
    },
    courseCode: { id: 'Kode MK', ar: 'رمز المادة' },
    courseName: { id: 'Mata Pelajaran / Mata Kuliah', ar: 'المادة الدراسية' },
    programParentName: { id: 'Program Induk', ar: 'البرنامج الدراسي' },
    creditHours: { id: 'SKS / Bobot', ar: 'الساعات' },
    numericalGrade: { id: 'Nilai Angka', ar: 'الدرجة الرقمية' },
    letterGradeCol: { id: 'Nilai Huruf', ar: 'الرمز' },
    predicateCol: { id: 'Predikat', ar: 'التقدير' },
    statusCol: { id: 'Status Kelulusan', ar: 'حالة الاجتياز' },
    semesterGpaLabel: { id: 'Indeks Prestasi Semester (IPS)', ar: 'معدل الفصل' },
    semesterCreditsLabel: { id: 'Beban SKS Semester', ar: 'ساعات الفصل' },
    printLegacyTranscript: {
      id: 'Cetak Transkrip Riwayat PDF',
      ar: 'طباعة كشف الدرجات السابق PDF',
    },
    legacyEmptyTitle: {
      id: 'Belum Ada Transkrip Riwayat Masa Lalu',
      ar: 'لا توجد سجلات درجات سابقة',
    },
    legacyEmptyDesc: {
      id: 'Akun Anda tidak memiliki data riwayat nilai dari sistem sebelumnya.',
      ar: 'لا يحتوي حسابك على بيانات درجات من النظام السابق.',
    },
    viewDetailModal: { id: 'Lihat Detail Nilai', ar: 'عرض تفاصيل الدرجة' },
    legacyOfficialDocTitle: {
      id: 'TRANSKRIP AKADEMIK RIWAYAT HASIL BELAJAR',
      ar: 'كشف الدرجات الأكاديمي للنتائج السابقة',
    },
  },

  certificates: {
    title: { id: 'Syahadah & Sertifikat', ar: 'الشهادات والإجازات' },
    subtitle: {
      id: 'Dokumen resmi kelulusan Anda dari setiap program yang telah diselesaikan.',
      ar: 'وثائق التخرج الرسمية الخاصة بك من كل برنامج أكملته.',
    },
    totalLabel: { id: 'Syahadah Tersedia', ar: 'شهادة متاحة' },
    loading: { id: 'Memuat syahadah...', ar: 'جاري تحميل الشهادات...' },
    emptyTitle: { id: 'Belum Ada Syahadah', ar: 'لا توجد شهادات بعد' },
    emptyDesc: {
      id: 'Selesaikan program untuk mendapatkan syahadah resmi kelulusan.',
      ar: 'أكمل البرنامج للحصول على شهادة التخرج الرسمية.',
    },
    browsePrograms: { id: 'Jelajahi Program', ar: 'تصفح البرامج' },
    earned: { id: 'Diperoleh', ar: 'تم الحصول عليها' },
    download: { id: 'Unduh', ar: 'تحميل' },
    downloadPdf: { id: 'Unduh Syahadah', ar: 'تحميل الشهادة' },
    unavailable: { id: 'Tidak Tersedia', ar: 'غير متاح' },
    close: { id: 'Tutup', ar: 'إغلاق' },
  },
  inactivity: {
    warningTitle: { id: 'Peringatan Sesi Tidak Aktif', ar: 'تنبيه انتهاء الجلسة بسبب عدم النشاط' },
    warningDesc: {
      id: 'Sesi Anda akan otomatis diakhiri untuk menghemat sumber daya server dalam waktu:',
      ar: 'ستنتهي جلستك تلقائيًا لتوفير موارد الخادم في غضون:',
    },
    countdownSuffix: { id: 'detik', ar: 'ثانية' },
    stayLoggedIn: { id: 'Tetap Masuk', ar: 'البقاء مسجلاً' },
    logoutNow: { id: 'Keluar Sekarang', ar: 'تسجيل الخروج الآن' },
  },
};
